
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6YvRD", function(module, exports) {
module.exports = JSON.parse("{\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("ineA9", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.admin-hub-recommendation.actions-heading":[{"type":0,"value":"Actions"}],"growth.admin-hub-recommendation.free-plan":[{"type":0,"value":"Free, cancel anytime"}],"growth.admin-hub-recommendation.heading":[{"type":0,"value":"Recommended based on your existing products"}],"growth.admin-hub-recommendation.plan-heading":[{"type":0,"value":"Plan"}],"growth.admin-hub-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-dynamic-description.value-proposition":[{"type":0,"value":"Plan, track, and organize any project"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name-for-use-case":[{"type":0,"value":"Screen recorder"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.value-proposition-for-use-case":[{"type":0,"value":"Record and share with an instant link"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"jpd.customRoadmapsPlacementHeader":[{"type":0,"value":"Custom roadmaps"}],"jpd.customRoadmapsPlacementTagLine":[{"type":0,"value":"Create and share high-level plans"}],"jpd.deliveryProgressPlacementHeader":[{"type":0,"value":"Delivery progress"}],"jpd.deliveryProgressPlacementTagLine":[{"type":0,"value":"Connect ideas to delivery status"}],"jpd.ideasAndPrioritiesPlacementHeader":[{"type":0,"value":"Ideas and priorities"}],"jpd.ideasAndPrioritiesPlacementTagLine":[{"type":0,"value":"Use RICE and data to prioritize ideas"}],"jpd.insightsAndIdeasPlacementHeader":[{"type":0,"value":"Insights and ideas"}],"jpd.insightsAndIdeasPlacementTagLine":[{"type":0,"value":"See ideas and feedback in one place"}],"jsm.assetsPlacementHeader":[{"type":0,"value":"Assets"}],"jsm.assetsPlacementTagLine":[{"type":0,"value":"Bring your enterprise assets together"}],"jsm.bugTrackingPlacementHeader":[{"type":0,"value":"Bug tracking"}],"jsm.bugTrackingPlacementTagLine":[{"type":0,"value":"Gather and resolve bugs in one place"}],"jsm.changeManagementPlacementHeader":[{"type":0,"value":"Change management"}],"jsm.changeManagementPlacementTagLine":[{"type":0,"value":"Create one place to manage changes"}],"jsm.customerServicePlacementHeader":[{"type":0,"value":"Customer service"}],"jsm.customerServicePlacementTagLine":[{"type":0,"value":"Help people get service and support"}],"jsm.helpDeskPlacementHeader":[{"type":0,"value":"Help desk"}],"jsm.helpDeskPlacementTagLine":[{"type":0,"value":"Receive requests and provide support"}],"jsm.issueManagementPlacementHeader":[{"type":0,"value":"Issue management"}],"jsm.issueManagementPlacementTagLine":[{"type":0,"value":"Capture and resolve issues"}],"jsm.onCallSchedulesPlacementHeader":[{"type":0,"value":"On-call schedules"}],"jsm.onCallSchedulesPlacementTagLine":[{"type":0,"value":"Create schedules, rotations, and more"}],"jsm.workRequestsPlacementHeader":[{"type":0,"value":"Work requests"}],"jsm.workRequestsPlacementTagLine":[{"type":0,"value":"Create one place to manage requests"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.growth.jira-assigned-nudge.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-section.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("8Mosz", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message-digest-email-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-email-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message-microsoft-teams.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, this is test message from Post Office: \"},{\"type\":1,\"value\":\"text\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted test mobile push notification from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.app-switcher-upgrade-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-upgrade-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Redacted Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-email.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate\":[{\"type\":0,\"value\":\"This is a redacted test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-message-failures.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-message-failures.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate\":[{\"type\":1,\"value\":\"greeting\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi,\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");

});

parcelRegister("jQRRW", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $221a2b03be5b44a4$export$a5d940130f33be3f);

var $7UHDa = parcelRequire("7UHDa");

var $5pS3b = parcelRequire("5pS3b");
const $221a2b03be5b44a4$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5pS3b.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...props
            })
        });
    };

});
parcelRegister("5pS3b", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $b2d267b4c02f41c6$export$480518999dfc4151);

var $7UHDa = parcelRequire("7UHDa");

var $7XIdu = parcelRequire("7XIdu");

var $hlhtG = parcelRequire("hlhtG");
var $dBxQj = parcelRequire("dBxQj");

var $ewi8o = parcelRequire("ewi8o");
function $b2d267b4c02f41c6$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $dBxQj.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $b2d267b4c02f41c6$export$480518999dfc4151(props) {
    const { locale: locale } = $b2d267b4c02f41c6$var$useFetchLocale();
    const messages = (0, $ewi8o.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}

});
parcelRegister("7XIdu", function(module, exports) {

$parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", () => $ddf71c7c19f3c4df$export$57d19d18d6e255a5);

var $inPa6 = parcelRequire("inPa6");

var $gwFzn = parcelRequire("gwFzn");
const $ddf71c7c19f3c4df$export$85183a312807388d = 'postOffice';
const $ddf71c7c19f3c4df$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $gwFzn.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($ddf71c7c19f3c4df$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});

parcelRegister("ewi8o", function(module, exports) {

$parcel$export(module.exports, "useIntlMessages", () => $9f428f426036dbfa$export$2641ec9a2025a81f);

var $7XIdu = parcelRequire("7XIdu");

var $gwFzn = parcelRequire("gwFzn");
const $9f428f426036dbfa$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $gwFzn.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};

});



parcelRegister("8SCD0", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $e6c9af975b930043$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ineA9 = parcelRequire("ineA9");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6c9af975b930043$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;































const $e6c9af975b930043$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4gCuh")));
        case 'da':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("aKB6h")));
        case 'de':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3xTit")));
        case 'en-GB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("czu29")));
        case 'en-US':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("e5mYd")));
        case 'en-XA':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dIcAj")));
        case 'en-XB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iIKoF")));
        case 'en-ZZ':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("jOmZE")));
        case 'en':
            return $e6c9af975b930043$var$importHelper(await Promise.resolve((parcelRequire("ineA9"))));
        case 'es':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("fFRNT")));
        case 'et':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("32noh")));
        case 'fi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("fxuYz")));
        case 'fr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("l3Eye")));
        case 'hu':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("f7ky6")));
        case 'it':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7as9r")));
        case 'ja':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("76QyX")));
        case 'ko':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4Qc7k")));
        case 'nb':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2MU1N")));
        case 'nl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4YZVZ")));
        case 'pl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("it51F")));
        case 'pt-BR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("1F6qu")));
        case 'ro':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hROdq")));
        case 'ru':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("1LJw7")));
        case 'sv':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("huY3L")));
        case 'th':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kVYlY")));
        case 'tr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("8QxWk")));
        case 'uk':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hVm6V")));
        case 'vi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("i2Gvh")));
        case 'zh-CN':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3rvZL")));
        case 'zh-TW':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3A0MI")));
        case 'zh':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3rvZL")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ineA9));
    }
};

});
parcelRegister("4gCuh", function(module, exports) {

let $31b682d549a0fd9b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $31b682d549a0fd9b$var$load("i5eMd").then(()=>parcelRequire('bvjlk'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("aKB6h", function(module, exports) {

let $7d3afa9d7cd5044f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d3afa9d7cd5044f$var$load("4UPfH").then(()=>parcelRequire('IzetR'));

});

parcelRegister("3xTit", function(module, exports) {

let $294f5900d1665cc6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $294f5900d1665cc6$var$load("gd4qs").then(()=>parcelRequire('b60fG'));

});

parcelRegister("czu29", function(module, exports) {

let $92700d00278c05ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $92700d00278c05ec$var$load("fviv5").then(()=>parcelRequire('d1j2S'));

});

parcelRegister("e5mYd", function(module, exports) {

let $a41359bbf51483d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a41359bbf51483d3$var$load("hEkXc").then(()=>parcelRequire('dnFPq'));

});

parcelRegister("dIcAj", function(module, exports) {

let $9fb9257e8f004e1e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9fb9257e8f004e1e$var$load("6oOC9").then(()=>parcelRequire('4WIcD'));

});

parcelRegister("iIKoF", function(module, exports) {

let $da10537d6882eb83$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $da10537d6882eb83$var$load("le1sE").then(()=>parcelRequire('7DdDO'));

});

parcelRegister("jOmZE", function(module, exports) {

let $e6c485d61d80957f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e6c485d61d80957f$var$load("eBoC7").then(()=>parcelRequire('hWRzS'));

});

parcelRegister("fFRNT", function(module, exports) {

let $b6946ba29168eee5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b6946ba29168eee5$var$load("bNv64").then(()=>parcelRequire('c7q37'));

});

parcelRegister("32noh", function(module, exports) {

let $2363b3de6d4c361f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2363b3de6d4c361f$var$load("bAoKR").then(()=>parcelRequire('6eH2E'));

});

parcelRegister("fxuYz", function(module, exports) {

let $b501f73eb9c01946$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b501f73eb9c01946$var$load("4Afgd").then(()=>parcelRequire('Plo13'));

});

parcelRegister("l3Eye", function(module, exports) {

let $f549556471decd0d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f549556471decd0d$var$load("cMubu").then(()=>parcelRequire('iY0zC'));

});

parcelRegister("f7ky6", function(module, exports) {

let $b0177311b6470e9f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b0177311b6470e9f$var$load("3fLE9").then(()=>parcelRequire('lqPAG'));

});

parcelRegister("7as9r", function(module, exports) {

let $537f4ddb2ec636fd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $537f4ddb2ec636fd$var$load("8hOn0").then(()=>parcelRequire('85Nk7'));

});

parcelRegister("76QyX", function(module, exports) {

let $52d1ddccab26d8ad$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $52d1ddccab26d8ad$var$load("h4OCL").then(()=>parcelRequire('gdGRk'));

});

parcelRegister("4Qc7k", function(module, exports) {

let $38656afb586d425b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $38656afb586d425b$var$load("bcQs2").then(()=>parcelRequire('eVsDT'));

});

parcelRegister("2MU1N", function(module, exports) {

let $207b8670a2090b06$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $207b8670a2090b06$var$load("aBa7j").then(()=>parcelRequire('76Zjl'));

});

parcelRegister("4YZVZ", function(module, exports) {

let $3a0ccee1344f3378$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3a0ccee1344f3378$var$load("b544F").then(()=>parcelRequire('8JOK1'));

});

parcelRegister("it51F", function(module, exports) {

let $d71ed57ac31d7d73$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d71ed57ac31d7d73$var$load("K6fhx").then(()=>parcelRequire('5eTse'));

});

parcelRegister("1F6qu", function(module, exports) {

let $135e9ae57572fc2b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $135e9ae57572fc2b$var$load("gZU54").then(()=>parcelRequire('1OKs8'));

});

parcelRegister("hROdq", function(module, exports) {

let $d01e56aadfa3e1c7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d01e56aadfa3e1c7$var$load("hlJc4").then(()=>parcelRequire('Xa5VS'));

});

parcelRegister("1LJw7", function(module, exports) {

let $149d7cfd5ce1c351$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $149d7cfd5ce1c351$var$load("4Wdqb").then(()=>parcelRequire('7W27q'));

});

parcelRegister("huY3L", function(module, exports) {

let $cbd3d3981dbe4b82$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cbd3d3981dbe4b82$var$load("k10Cs").then(()=>parcelRequire('6CeqQ'));

});

parcelRegister("kVYlY", function(module, exports) {

let $f3d7f2733d894d43$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f3d7f2733d894d43$var$load("g5LV7").then(()=>parcelRequire('88szQ'));

});

parcelRegister("8QxWk", function(module, exports) {

let $670d81cf18ad951a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $670d81cf18ad951a$var$load("1n8w9").then(()=>parcelRequire('8mq9f'));

});

parcelRegister("hVm6V", function(module, exports) {

let $d0c8e949da6b9da5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d0c8e949da6b9da5$var$load("2QtDQ").then(()=>parcelRequire('gOCry'));

});

parcelRegister("i2Gvh", function(module, exports) {

let $d2296231d9d45e0f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d2296231d9d45e0f$var$load("i2vEA").then(()=>parcelRequire('8bOb4'));

});

parcelRegister("3rvZL", function(module, exports) {

let $281cb64eec2931e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $281cb64eec2931e6$var$load("f1B4n").then(()=>parcelRequire('03O98'));

});

parcelRegister("3A0MI", function(module, exports) {

let $29b557b82cced2b4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $29b557b82cced2b4$var$load("l079e").then(()=>parcelRequire('eLabs'));

});


parcelRegister("3nDO6", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $8393a846181017db$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6YvRD = parcelRequire("6YvRD");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8393a846181017db$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $8393a846181017db$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8393a846181017db$var$importHelper(await (parcelRequire("1F8PS")));
        case 'da':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kk0Dg")));
        case 'de':
            return $8393a846181017db$var$importHelper(await (parcelRequire("dmjL7")));
        case 'en-GB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cfn7s")));
        case 'en-US':
            return $8393a846181017db$var$importHelper(await (parcelRequire("2UBSA")));
        case 'en-XA':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8IIdi")));
        case 'en-XB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kACr1")));
        case 'en-ZZ':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8uZhS")));
        case 'en':
            return $8393a846181017db$var$importHelper(await Promise.resolve((parcelRequire("6YvRD"))));
        case 'es':
            return $8393a846181017db$var$importHelper(await (parcelRequire("2OnQ5")));
        case 'et':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bwUqh")));
        case 'fi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cxakJ")));
        case 'fr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("7YB9E")));
        case 'hu':
            return $8393a846181017db$var$importHelper(await (parcelRequire("lCzXr")));
        case 'it':
            return $8393a846181017db$var$importHelper(await (parcelRequire("gTZbf")));
        case 'ja':
            return $8393a846181017db$var$importHelper(await (parcelRequire("c4dvE")));
        case 'ko':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bIHhK")));
        case 'nb':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eOFtl")));
        case 'nl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("hDqVC")));
        case 'pl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("3OaWD")));
        case 'pt-BR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ghFPe")));
        case 'ro':
            return $8393a846181017db$var$importHelper(await (parcelRequire("lIhRt")));
        case 'ru':
            return $8393a846181017db$var$importHelper(await (parcelRequire("9Y4Ru")));
        case 'sv':
            return $8393a846181017db$var$importHelper(await (parcelRequire("hdCEv")));
        case 'th':
            return $8393a846181017db$var$importHelper(await (parcelRequire("fYYyy")));
        case 'tr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bCm0G")));
        case 'uk':
            return $8393a846181017db$var$importHelper(await (parcelRequire("9robZ")));
        case 'vi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("aG2Bm")));
        case 'zh-CN':
            return $8393a846181017db$var$importHelper(await (parcelRequire("949j6")));
        case 'zh-TW':
            return $8393a846181017db$var$importHelper(await (parcelRequire("7um3i")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6YvRD));
    }
};

});
parcelRegister("1F8PS", function(module, exports) {

let $136079612fc4e9f7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $136079612fc4e9f7$var$load("bv8GZ").then(()=>parcelRequire('74xff'));

});

parcelRegister("kk0Dg", function(module, exports) {

let $ecb62a7403f009af$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ecb62a7403f009af$var$load("cdeuH").then(()=>parcelRequire('hQIGt'));

});

parcelRegister("dmjL7", function(module, exports) {

let $9b9ca829d417e593$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9b9ca829d417e593$var$load("7gF8f").then(()=>parcelRequire('j9sSr'));

});

parcelRegister("cfn7s", function(module, exports) {

let $8ea8d1c489e562b7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8ea8d1c489e562b7$var$load("djb49").then(()=>parcelRequire('4tVXT'));

});

parcelRegister("2UBSA", function(module, exports) {

let $21ee31c8724447e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21ee31c8724447e5$var$load("koawN").then(()=>parcelRequire('k7TQm'));

});

parcelRegister("8IIdi", function(module, exports) {

let $6594baac33897764$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6594baac33897764$var$load("6htQT").then(()=>parcelRequire('lIWyQ'));

});

parcelRegister("kACr1", function(module, exports) {

let $efd4fbc5ec1f9e1d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $efd4fbc5ec1f9e1d$var$load("fi75i").then(()=>parcelRequire('5QCdA'));

});

parcelRegister("8uZhS", function(module, exports) {

let $6300aa71c10ccf3e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6300aa71c10ccf3e$var$load("ksTQ6").then(()=>parcelRequire('4EAWY'));

});

parcelRegister("2OnQ5", function(module, exports) {

let $20c2be410e137536$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $20c2be410e137536$var$load("5CGnz").then(()=>parcelRequire('1PSNt'));

});

parcelRegister("bwUqh", function(module, exports) {

let $864e734815f334fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $864e734815f334fe$var$load("X0Jic").then(()=>parcelRequire('cNrRQ'));

});

parcelRegister("cxakJ", function(module, exports) {

let $9200951f82e878d2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9200951f82e878d2$var$load("9Oxgj").then(()=>parcelRequire('5L1ix'));

});

parcelRegister("7YB9E", function(module, exports) {

let $5ceaf51ff3e9db67$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5ceaf51ff3e9db67$var$load("kAg8V").then(()=>parcelRequire('f4vYC'));

});

parcelRegister("lCzXr", function(module, exports) {

let $fbd90a0817a8740a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fbd90a0817a8740a$var$load("fM2oh").then(()=>parcelRequire('lmfGu'));

});

parcelRegister("gTZbf", function(module, exports) {

let $c4e13d90af3270d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c4e13d90af3270d3$var$load("xnqy2").then(()=>parcelRequire('J7CId'));

});

parcelRegister("c4dvE", function(module, exports) {

let $8c905673636be71f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8c905673636be71f$var$load("awkVi").then(()=>parcelRequire('iEu8X'));

});

parcelRegister("bIHhK", function(module, exports) {

let $888561520b0bebbf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $888561520b0bebbf$var$load("11DLa").then(()=>parcelRequire('lklBt'));

});

parcelRegister("eOFtl", function(module, exports) {

let $ac95e7b7a60cecfb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ac95e7b7a60cecfb$var$load("barSq").then(()=>parcelRequire('edhkG'));

});

parcelRegister("hDqVC", function(module, exports) {

let $cd6af79a32b1b8c7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cd6af79a32b1b8c7$var$load("a8heY").then(()=>parcelRequire('aFb9z'));

});

parcelRegister("3OaWD", function(module, exports) {

let $2c5e87fece611498$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2c5e87fece611498$var$load("6hlNE").then(()=>parcelRequire('bAPfw'));

});

parcelRegister("ghFPe", function(module, exports) {

let $bdaead80a9a43b5e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bdaead80a9a43b5e$var$load("2bqSD").then(()=>parcelRequire('c1E8Q'));

});

parcelRegister("lIhRt", function(module, exports) {

let $fceb8fee3c031379$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fceb8fee3c031379$var$load("j6IGj").then(()=>parcelRequire('88y6K'));

});

parcelRegister("9Y4Ru", function(module, exports) {

let $741d7d113b0b73b3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $741d7d113b0b73b3$var$load("bJykp").then(()=>parcelRequire('8Rjw5'));

});

parcelRegister("hdCEv", function(module, exports) {

let $c891a2229252db84$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c891a2229252db84$var$load("dh2Er").then(()=>parcelRequire('6TlJn'));

});

parcelRegister("fYYyy", function(module, exports) {

let $ba2b6edb2f741171$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ba2b6edb2f741171$var$load("kyBJI").then(()=>parcelRequire('7Nysq'));

});

parcelRegister("bCm0G", function(module, exports) {

let $87545107d0c054d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $87545107d0c054d1$var$load("eBLgB").then(()=>parcelRequire('1gaUd'));

});

parcelRegister("9robZ", function(module, exports) {

let $6df966c50dc10ee3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6df966c50dc10ee3$var$load("ahhGv").then(()=>parcelRequire('bcwM6'));

});

parcelRegister("aG2Bm", function(module, exports) {

let $7c5fd83975789152$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7c5fd83975789152$var$load("1Zesg").then(()=>parcelRequire('7fZ9R'));

});

parcelRegister("949j6", function(module, exports) {

let $699bb4fd25605671$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $699bb4fd25605671$var$load("eLlpV").then(()=>parcelRequire('15VSW'));

});

parcelRegister("7um3i", function(module, exports) {

let $573c70dda0c9847c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $573c70dda0c9847c$var$load("bV8sS").then(()=>parcelRequire('dU88R'));

});


parcelRegister("kdvUL", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $a5b98d263d96b9ca$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8Mosz = parcelRequire("8Mosz");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a5b98d263d96b9ca$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $a5b98d263d96b9ca$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("lgYjG")));
        case 'da':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aMvW6")));
        case 'de':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("hhXZB")));
        case 'en-GB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("kYlvw")));
        case 'en-US':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("kMHjk")));
        case 'en-XA':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2TtYJ")));
        case 'en-XB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("gcbIg")));
        case 'en-ZZ':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6UJcw")));
        case 'en':
            return $a5b98d263d96b9ca$var$importHelper(await Promise.resolve((parcelRequire("8Mosz"))));
        case 'es':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("1Wy93")));
        case 'et':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Klw4")));
        case 'fi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("hzXCu")));
        case 'fr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("It92o")));
        case 'hu':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Ph0I")));
        case 'it':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("cfFfg")));
        case 'ja':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("jyaSl")));
        case 'ko':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("f8elT")));
        case 'nb':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7tONR")));
        case 'nl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Zb6O")));
        case 'pl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("3AE5f")));
        case 'pt-BR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("8z7BF")));
        case 'ro':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("GyNeb")));
        case 'ru':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5ONF5")));
        case 'sv':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5zENw")));
        case 'th':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5IRx0")));
        case 'tr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("adVJa")));
        case 'uk':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bZV8f")));
        case 'vi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("853SZ")));
        case 'zh-CN':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aOyE3")));
        case 'zh-TW':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("cBu0O")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8Mosz));
    }
};

});
parcelRegister("lgYjG", function(module, exports) {

let $f7c9e12e02706323$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7c9e12e02706323$var$load("1jsQH").then(()=>parcelRequire('fa8lP'));

});

parcelRegister("aMvW6", function(module, exports) {

let $7d9728ebd0cc0255$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d9728ebd0cc0255$var$load("deyvi").then(()=>parcelRequire('e3sAb'));

});

parcelRegister("hhXZB", function(module, exports) {

let $c9628f7bd61c0517$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c9628f7bd61c0517$var$load("6dERU").then(()=>parcelRequire('gch8x'));

});

parcelRegister("kYlvw", function(module, exports) {

let $f44a18250432e8da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f44a18250432e8da$var$load("kTurq").then(()=>parcelRequire('8ptsW'));

});

parcelRegister("kMHjk", function(module, exports) {

let $f219e2f98c7e6fef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f219e2f98c7e6fef$var$load("fbIIm").then(()=>parcelRequire('a6GY6'));

});

parcelRegister("2TtYJ", function(module, exports) {

let $21b7f8f58a479391$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21b7f8f58a479391$var$load("7l3it").then(()=>parcelRequire('8fxxk'));

});

parcelRegister("gcbIg", function(module, exports) {

let $bca6da459c328a88$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bca6da459c328a88$var$load("i64HJ").then(()=>parcelRequire('efBlj'));

});

parcelRegister("6UJcw", function(module, exports) {

let $508b08ff258adc64$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $508b08ff258adc64$var$load("j0PWv").then(()=>parcelRequire('ks6TI'));

});

parcelRegister("1Wy93", function(module, exports) {

let $16a5b1b54bc06544$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $16a5b1b54bc06544$var$load("dlmud").then(()=>parcelRequire('imT4f'));

});

parcelRegister("6Klw4", function(module, exports) {

let $4e97baa60f886ac0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4e97baa60f886ac0$var$load("7snhF").then(()=>parcelRequire('cQTYN'));

});

parcelRegister("hzXCu", function(module, exports) {

let $ccc3f3cf413db973$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ccc3f3cf413db973$var$load("cbkj0").then(()=>parcelRequire('j8AG8'));

});

parcelRegister("It92o", function(module, exports) {

let $085ab7b826eaff2f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $085ab7b826eaff2f$var$load("17m16").then(()=>parcelRequire('cdNFz'));

});

parcelRegister("6Ph0I", function(module, exports) {

let $4f84b372495070be$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4f84b372495070be$var$load("b4NO6").then(()=>parcelRequire('gPFiy'));

});

parcelRegister("cfFfg", function(module, exports) {

let $8eb6e12e32de23d0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8eb6e12e32de23d0$var$load("1K1Fj").then(()=>parcelRequire('dIMMS'));

});

parcelRegister("jyaSl", function(module, exports) {

let $e3b9a0ee8175e77b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e3b9a0ee8175e77b$var$load("38sfA").then(()=>parcelRequire('css4w'));

});

parcelRegister("f8elT", function(module, exports) {

let $b042bc67bf906637$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b042bc67bf906637$var$load("bjmre").then(()=>parcelRequire('9R9u0'));

});

parcelRegister("7tONR", function(module, exports) {

let $5722a64fa2d6109b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5722a64fa2d6109b$var$load("asvK9").then(()=>parcelRequire('6DTdr'));

});

parcelRegister("6Zb6O", function(module, exports) {

let $51610e8e9990c64a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $51610e8e9990c64a$var$load("7v6wU").then(()=>parcelRequire('ceZMk'));

});

parcelRegister("3AE5f", function(module, exports) {

let $29d3d3a83b915225$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $29d3d3a83b915225$var$load("aEpRh").then(()=>parcelRequire('jtjwW'));

});

parcelRegister("8z7BF", function(module, exports) {

let $63c77e170fd2851d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $63c77e170fd2851d$var$load("3fuR9").then(()=>parcelRequire('l8CqS'));

});

parcelRegister("GyNeb", function(module, exports) {

let $07fee985e2aa8d66$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $07fee985e2aa8d66$var$load("bSjyK").then(()=>parcelRequire('fFbIU'));

});

parcelRegister("5ONF5", function(module, exports) {

let $43c82508b519f717$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $43c82508b519f717$var$load("fMrUo").then(()=>parcelRequire('hHfxK'));

});

parcelRegister("5zENw", function(module, exports) {

let $40efde36d68433dd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $40efde36d68433dd$var$load("9eNkX").then(()=>parcelRequire('2OLbL'));

});

parcelRegister("5IRx0", function(module, exports) {

let $42aa96001a33cb5b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $42aa96001a33cb5b$var$load("fTPgj").then(()=>parcelRequire('lSTN4'));

});

parcelRegister("adVJa", function(module, exports) {

let $7717e5be3b377e8d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7717e5be3b377e8d$var$load("h0uBE").then(()=>parcelRequire('74ATO'));

});

parcelRegister("bZV8f", function(module, exports) {

let $8bc1b571ad8da4cf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8bc1b571ad8da4cf$var$load("lKa7i").then(()=>parcelRequire('3fixv'));

});

parcelRegister("853SZ", function(module, exports) {

let $5e21ce045e22b771$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5e21ce045e22b771$var$load("9aufD").then(()=>parcelRequire('kafqC'));

});

parcelRegister("aOyE3", function(module, exports) {

let $7df972b1010b14c0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7df972b1010b14c0$var$load("gDiIK").then(()=>parcelRequire('19yAM'));

});

parcelRegister("cBu0O", function(module, exports) {

let $92d03884d22bdbde$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $92d03884d22bdbde$var$load("j9OUx").then(()=>parcelRequire('jSsWA'));

});


parcelRegister("9QvUi", function(module, exports) {

$parcel$export(module.exports, "default", () => $13bb23ac78effffb$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $4H1Ql = parcelRequire("4H1Ql");

var $NT2w1 = parcelRequire("NT2w1");

var $2mPpz = parcelRequire("2mPpz");

var $gwFzn = parcelRequire("gwFzn");

var $2xYsH = parcelRequire("2xYsH");

var $hnA4H = parcelRequire("hnA4H");
const $13bb23ac78effffb$var$STABLE_OBJECT = {};
const $13bb23ac78effffb$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $gwFzn.useMemo)(()=>(0, $2mPpz.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $4H1Ql.useStableObject)(placementProps ?? $13bb23ac78effffb$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $NT2w1.default), {
        placementId: placementId,
        consumptionType: "local",
        onEvent: onEvent,
        disableInitialData: disableInitialData,
        children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2xYsH.default), {
                analyticsChannel: (0, $hnA4H.ANALYTICS_CHANNEL),
                placementId: placementId,
                onError: sharedOnEvent,
                fallback: ErrorFallback,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(MemoizedPlacement, {
                    initialData: initialData,
                    context: context,
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore - Confluence Local Consumption
                    errorFallback: ErrorFallback,
                    ...stableLocalPlacementProps,
                    children: children
                })
            })
    });
};
var $13bb23ac78effffb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $gwFzn.memo)($13bb23ac78effffb$var$Placement);

});
parcelRegister("4H1Ql", function(module, exports) {

$parcel$export(module.exports, "useStableObject", () => $6932c2b531d219ac$export$ed02d4adf2068b08);

var $gwFzn = parcelRequire("gwFzn");
function $6932c2b531d219ac$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $6932c2b531d219ac$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $gwFzn.useMemo)(()=>obj, $6932c2b531d219ac$export$cdf98ded28406f69(obj));
}

});

parcelRegister("NT2w1", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ab3a0c2f45d583$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $ffCOo = parcelRequire("ffCOo");

var $PAiZW = parcelRequire("PAiZW");
var $6yHRM = parcelRequire("6yHRM");
var $4H1Ql = parcelRequire("4H1Ql");

var $3NyPa = parcelRequire("3NyPa");
var $h6POP = parcelRequire("h6POP");

var $kO3gu = parcelRequire("kO3gu");

var $gwFzn = parcelRequire("gwFzn");

var $dE7qQ = parcelRequire("dE7qQ");

var $5dPMD = parcelRequire("5dPMD");

var $dug7n = parcelRequire("dug7n");
const $80ab3a0c2f45d583$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    return (0, $gwFzn.useMemo)(()=>disableInitialData ? undefined : (0, $5dPMD.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
const $80ab3a0c2f45d583$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $dug7n.useBuildBasePath)();
    const stableContextWithRoute = (0, $4H1Ql.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $gwFzn.useMemo)(()=>isUFOEnabled ? new (0, $3NyPa.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    // Callback function to listen to the different stages of the remote component and track its performance
    const remoteComponentOnEvent = (0, $gwFzn.useCallback)(({ type: type, error: error })=>{
        placementOnEvent?.({
            type: type,
            error: error
        });
        switch(type){
            case 'fetch-complete':
                ufoV1PlacementTracker?.markFetchComplete();
                break;
            case 'fetch-error':
                ufoV1PlacementTracker?.markFetchFailure(error);
                break;
            case 'render-complete':
                ufoV1PlacementTracker?.markRenderComplete();
                break;
            case 'render-error':
                ufoV1PlacementTracker?.markRenderFailure(error);
                break;
            case 'initial-data-complete':
                ufoV1PlacementTracker?.markInitialDataComplete();
                break;
            case 'initial-data-error':
                ufoV1PlacementTracker?.markInitialDataFailure(error);
                break;
            case 'component-error':
                ufoV1PlacementTracker?.markComponentFailure(error);
                break;
            case 'component-ready':
                ufoV1PlacementTracker?.markComponentReady();
                break;
            case 'unmount':
                ufoV1PlacementTracker?.markComponentAborted();
                break;
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker
    ]);
    const initialData = $80ab3a0c2f45d583$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $gwFzn.useMemo)(()=>({
            source: (0, $dE7qQ.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($80ab3a0c2f45d583$var$FeatureFlaggedUfoWrapper, {
        placementId: placementId,
        isEnabled: isUFOEnabled,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext,
            children: children({
                initialData: initialData,
                context: stableContextWithRoute,
                onEvent: remoteComponentOnEvent
            })
        })
    });
};
var $80ab3a0c2f45d583$export$2e2bcd8739ae039 = $80ab3a0c2f45d583$var$Placement;
const $80ab3a0c2f45d583$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
};

});
parcelRegister("PAiZW", function(module, exports) {

$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $6cd46b79c049adec$export$da5dc9062cba6715);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $6cd46b79c049adec$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $6cd46b79c049adec$export$b77983be89bb0a4e);
$parcel$export(module.exports, "usePostOfficeContext", () => $6cd46b79c049adec$export$5bd9099e0ae94a43);

var $gwFzn = parcelRequire("gwFzn");
const $6cd46b79c049adec$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $6cd46b79c049adec$export$a228be81fcb77b42 = (0, $gwFzn.createContext)($6cd46b79c049adec$export$da5dc9062cba6715);
const $6cd46b79c049adec$export$3a10495c2cd2db0c = $6cd46b79c049adec$export$a228be81fcb77b42.Provider;
const $6cd46b79c049adec$export$b77983be89bb0a4e = $6cd46b79c049adec$export$3a10495c2cd2db0c;
const $6cd46b79c049adec$export$5bd9099e0ae94a43 = ()=>(0, $gwFzn.useContext)($6cd46b79c049adec$export$a228be81fcb77b42);

});

parcelRegister("6yHRM", function(module, exports) {

$parcel$export(module.exports, "PostOfficeRouteContext", () => $d8346e8a2779e8cd$export$f7f47a74e8b47b1f);
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e);
$parcel$export(module.exports, "usePostOfficeRoute", () => $d8346e8a2779e8cd$export$79301b66f7808cd8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $le4qT = parcelRequire("le4qT");

var $4H1Ql = parcelRequire("4H1Ql");
const $d8346e8a2779e8cd$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $d8346e8a2779e8cd$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $d8346e8a2779e8cd$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $le4qT.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $4H1Ql.useStableObject)(route);
};
const $d8346e8a2779e8cd$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $d8346e8a2779e8cd$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$d8346e8a2779e8cd$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $d8346e8a2779e8cd$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $gwFzn.createContext)($d8346e8a2779e8cd$var$initialState);
const $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $gwFzn.useRef)();
    if (!ref.current) ref.current = $d8346e8a2779e8cd$export$98c77e1bd702ed15(props);
    const route = $d8346e8a2779e8cd$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($d8346e8a2779e8cd$export$f7f47a74e8b47b1f.Provider, {
        value: route,
        children: children
    });
};
const $d8346e8a2779e8cd$export$79301b66f7808cd8 = ()=>(0, $gwFzn.useContext)($d8346e8a2779e8cd$export$f7f47a74e8b47b1f); //Route listener

});

parcelRegister("3NyPa", function(module, exports) {

$parcel$export(module.exports, "UFOv1", () => $959aa8656bf0972c$export$96236906ebaa7f87);

var $jTlSd = parcelRequire("jTlSd");

var $koKWt = parcelRequire("koKWt");
const $959aa8656bf0972c$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jTlSd.MessagePerformanceTracker,
    PlacementPerformanceTracker: $koKWt.PlacementPerformanceTracker
};

});
parcelRegister("jTlSd", function(module, exports) {

$parcel$export(module.exports, "MessagePerformanceTracker", () => $71d7f78b2ff13923$export$ae5c73c7c4f454e6);

var $9NDUe = parcelRequire("9NDUe");
var $5aVN7 = parcelRequire("5aVN7");

var $haNjI = parcelRequire("haNjI");
class $71d7f78b2ff13923$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("haNjI", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceNames", () => $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $ac68ec5e99dfa5a8$export$6d482cfa20c9d220);
const $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $ac68ec5e99dfa5a8$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("koKWt", function(module, exports) {

$parcel$export(module.exports, "PlacementPerformanceTracker", () => $f3e04d171a04c0ba$export$8b48c2105ba0b35a);

var $9NDUe = parcelRequire("9NDUe");
var $5aVN7 = parcelRequire("5aVN7");

var $haNjI = parcelRequire("haNjI");
const $f3e04d171a04c0ba$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $9NDUe.ExperienceTypes).Load,
    platform: {
        component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $f3e04d171a04c0ba$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).PLACEMENT, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).PLACEMENT}.${placementId}`, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("h6POP", function(module, exports) {

$parcel$export(module.exports, "UFOv2", () => $7e9b04f8bb48d01d$export$c91b09caa8ecbab1);

var $fwDOR = parcelRequire("fwDOR");

var $hnvzE = parcelRequire("hnvzE");
const $7e9b04f8bb48d01d$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $fwDOR.default,
    UFOSegment: $hnvzE.default
};

});

parcelRegister("kO3gu", function(module, exports) {

$parcel$export(module.exports, "usePlacementFetchingContext", () => $1235947cddcdc3a4$export$e1e2cdb0425a9fa8);
$parcel$export(module.exports, "PlacementFetchingProvider", () => $1235947cddcdc3a4$export$5f25a6ddf0324fa8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $1235947cddcdc3a4$export$afec669dc416ee7e = /*#__PURE__*/ (0, $gwFzn.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $1235947cddcdc3a4$export$e1e2cdb0425a9fa8 = ()=>(0, $gwFzn.useContext)($1235947cddcdc3a4$export$afec669dc416ee7e);
const $1235947cddcdc3a4$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $gwFzn.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($1235947cddcdc3a4$export$afec669dc416ee7e.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("dE7qQ", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6);
const $2d2adb07a8ea6d4a$export$85183a312807388d = 'postOffice';
const $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6 = 'post-office-frontend';

});

parcelRegister("5dPMD", function(module, exports) {

$parcel$export(module.exports, "defaultFetcher", () => $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3);
$parcel$export(module.exports, "requestInitialData", () => $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab);
const $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("dug7n", function(module, exports) {

$parcel$export(module.exports, "useBuildBasePath", () => $f2f503b4228c54ff$export$83d6c58b7ab7ae67);

var $bnKhH = parcelRequire("bnKhH");
var $c3xd8 = parcelRequire("c3xd8");

var $gwFzn = parcelRequire("gwFzn");
const $f2f503b4228c54ff$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $c3xd8.usePostOfficeEnvironment)();
    return (0, $gwFzn.useMemo)(()=>(0, $bnKhH.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};

});
parcelRegister("bnKhH", function(module, exports) {

$parcel$export(module.exports, "buildBasePath", () => $121828a65173ad3f$export$e8b30f9c4a80230f);

var $7kqqb = parcelRequire("7kqqb");

var $c3xd8 = parcelRequire("c3xd8");
const $121828a65173ad3f$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $c3xd8.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $7kqqb.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});
parcelRegister("7kqqb", function(module, exports) {

$parcel$export(module.exports, "API_ORIGIN_TEST_SERVER", () => $5d54839cd273dd72$export$5ca004be156a127a);
$parcel$export(module.exports, "API_ORIGIN_LOCAL", () => $5d54839cd273dd72$export$1e9fed4c0197724c);
$parcel$export(module.exports, "API_PATHNAME_LOCAL", () => $5d54839cd273dd72$export$919a9569bce66f17);
$parcel$export(module.exports, "API_PATHNAME_STG_PROD", () => $5d54839cd273dd72$export$d4fe3482c88e73a8);
$parcel$export(module.exports, "REMOTE_MODULE_URI_LOCAL", () => $5d54839cd273dd72$export$67be2569ef5d7666);
$parcel$export(module.exports, "REMOTE_MODULE_URI_STG", () => $5d54839cd273dd72$export$b49738b89db261cd);
$parcel$export(module.exports, "REMOTE_MODULE_URI_PROD", () => $5d54839cd273dd72$export$bbd96cd490b0df63);
const $5d54839cd273dd72$export$5ca004be156a127a = 'http://localhost:4224';
const $5d54839cd273dd72$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $5d54839cd273dd72$export$1e9fed4c0197724c = 'http://localhost:8081';
const $5d54839cd273dd72$export$919a9569bce66f17 = '/api/v1/placements/';
const $5d54839cd273dd72$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $5d54839cd273dd72$export$67be2569ef5d7666 = 'http://localhost:9009';
const $5d54839cd273dd72$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $5d54839cd273dd72$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';

});

parcelRegister("c3xd8", function(module, exports) {

$parcel$export(module.exports, "defaultEnvironmentValues", () => $de5791e01a0486f7$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $de5791e01a0486f7$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $de5791e01a0486f7$export$877b97169cc75e8b);

var $gwFzn = parcelRequire("gwFzn");

var $7kqqb = parcelRequire("7kqqb");
const $de5791e01a0486f7$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        'test-server': {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_TEST_SERVER),
                pathname: (0, $7kqqb.API_ORIGIN_TEST_SERVER),
                searchParams: undefined
            }
        },
        test: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_STG),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_STG),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_PROD),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_PROD),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        }
    }
};
const $de5791e01a0486f7$export$fceca2c399b32565 = (0, $gwFzn.createContext)($de5791e01a0486f7$export$b4ede87479bfcf09);
const $de5791e01a0486f7$export$604607f913ef367c = $de5791e01a0486f7$export$fceca2c399b32565.Provider;
const $de5791e01a0486f7$export$877b97169cc75e8b = ()=>(0, $gwFzn.useContext)($de5791e01a0486f7$export$fceca2c399b32565);

});




parcelRegister("2mPpz", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $479bf4f98cf9c8c7$export$8a57effc6307f916);

var $byfJM = parcelRequire("byfJM");
const $479bf4f98cf9c8c7$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $byfJM.createPlacementComponent)(placementId, Component, placementConfigurationOptions);

});
parcelRegister("byfJM", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $573f4005c25c6dbc$export$8a57effc6307f916);

var $7UHDa = parcelRequire("7UHDa");

var $4H1Ql = parcelRequire("4H1Ql");

var $a8wvv = parcelRequire("a8wvv");

var $9dOtv = parcelRequire("9dOtv");

var $eXPKf = parcelRequire("eXPKf");
var $MnX4h = parcelRequire("MnX4h");

var $2HRxT = parcelRequire("2HRxT");
const $573f4005c25c6dbc$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $2HRxT.withErrorBoundary)((props)=>{
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $4H1Ql.useStableObject)(context);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eXPKf.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $MnX4h.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                choreographer: placementConfigurationOptions?.choreographer,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $573f4005c25c6dbc$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $573f4005c25c6dbc$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $9dOtv.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $a8wvv.ERROR_BOUNDARY_LOCATION),
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("a8wvv", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $f5ba185a6bfa7119$export$9c542858adf7dcd0);
$parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", () => $f5ba185a6bfa7119$export$71ff7382870ef1b0);
const $f5ba185a6bfa7119$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $f5ba185a6bfa7119$export$71ff7382870ef1b0 = 'create-placement-component';

});

parcelRegister("9dOtv", function(module, exports) {

$parcel$export(module.exports, "useComponentErrorHandling", () => $94fea169e2cb8de7$export$3d127465d22fe4e5);

var $gwFzn = parcelRequire("gwFzn");
const $94fea169e2cb8de7$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $gwFzn.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});

parcelRegister("eXPKf", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracking", () => $3a8bbfb177ab8743$export$9a335a42ce02bdb8);

var $7UHDa = parcelRequire("7UHDa");

var $c6GJD = parcelRequire("c6GJD");

var $h6POP = parcelRequire("h6POP");

var $fUB5z = parcelRequire("fUB5z");

var $a39tv = parcelRequire("a39tv");
const $3a8bbfb177ab8743$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
    const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $a39tv.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.PLACEMENT,
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                name: (0, $h6POP.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fUB5z.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
};

});
parcelRegister("fUB5z", function(module, exports) {

$parcel$export(module.exports, "TrackMount", () => $28f53716d0e10e9b$export$21b400a8c8ebc91a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $28f53716d0e10e9b$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $gwFzn.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});

parcelRegister("a39tv", function(module, exports) {

$parcel$export(module.exports, "usePerformanceTracking", () => $6d839c5f036ae335$export$317d52099614f316);

var $gwFzn = parcelRequire("gwFzn");
const $6d839c5f036ae335$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(true);
    const onMount = (0, $gwFzn.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $gwFzn.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};

});


parcelRegister("MnX4h", function(module, exports) {

$parcel$export(module.exports, "StableProviders", () => $e96f8aedef8f7ae2$export$2b6596bcb1383a71);

var $7UHDa = parcelRequire("7UHDa");

var $jfBff = parcelRequire("jfBff");

var $1Ah4R = parcelRequire("1Ah4R");

var $3zCGc = parcelRequire("3zCGc");

var $kzyrP = parcelRequire("kzyrP");

var $goPQE = parcelRequire("goPQE");

var $coAgb = parcelRequire("coAgb");

var $eXPKf = parcelRequire("eXPKf");
const $e96f8aedef8f7ae2$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kzyrP.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $goPQE.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $coAgb.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1Ah4R.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3zCGc.StableChoreographerProvider), {
                        choreographer: choreographer,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jfBff.RenderTrackerProvider), {
                            placementId: placement.placementId,
                            children: children
                        })
                    })
                })
            })
        })
    });

});
parcelRegister("jfBff", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerProvider", () => $5ba220ca4e76952d$export$2d84fd9af6c9e378);

var $7UHDa = parcelRequire("7UHDa");

var $7XIdu = parcelRequire("7XIdu");

var $gwFzn = parcelRequire("gwFzn");
/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $5ba220ca4e76952d$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        if ($5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement'
        });
    }, [
        fireAnalyticsEvent,
        placementId
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});

parcelRegister("1Ah4R", function(module, exports) {

$parcel$export(module.exports, "StableAnaltyicsProvider", () => $6622e517a1cb034d$export$5a66cdc9893b43e);

var $7UHDa = parcelRequire("7UHDa");

var $ffCOo = parcelRequire("ffCOo");
const $6622e517a1cb034d$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "a7d8a348de472382d5d2969e3f47e6e1a625ca97",
            b: "4413057",
            t: undefined
        }
    }
};
const $6622e517a1cb034d$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: $6622e517a1cb034d$var$postOfficeAnalyticsContextData,
        children: children
    });
};

});

parcelRegister("3zCGc", function(module, exports) {

$parcel$export(module.exports, "StableChoreographerProvider", () => $a6536447802fda47$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $a6536447802fda47$export$cab5a8adbabcee23);

var $7UHDa = parcelRequire("7UHDa");

var $PAiZW = parcelRequire("PAiZW");
var $c3xd8 = parcelRequire("c3xd8");

var $gwFzn = parcelRequire("gwFzn");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
const $a6536447802fda47$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
const $a6536447802fda47$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $a6536447802fda47$var$defaultContext = {
    choreographerEnabled: $a6536447802fda47$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $a6536447802fda47$var$ChoreographerContext = /*#__PURE__*/ (0, $gwFzn.createContext)($a6536447802fda47$var$defaultContext);

const $a6536447802fda47$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $gwFzn.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $gwFzn.useState)(choreographer?.isDefaultEnabled ?? $a6536447802fda47$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $c3xd8.usePostOfficeEnvironment)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    (0, $gwFzn.useEffect)(()=>{
        if (choreographerEnabled) (parcelRequire("lCnxw")).then((m)=>{
            const module = $a6536447802fda47$var$importHelper(m);
            setChoreographerFactory(new module.ChoreographerRegistry(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
        }).catch(()=>{
            setChoreographerEnabled(false);
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv
    ]);
    const stableChoreographerContext = (0, $gwFzn.useMemo)(()=>({
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        }), [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($a6536447802fda47$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $a6536447802fda47$export$cab5a8adbabcee23 = ()=>(0, $gwFzn.useContext)($a6536447802fda47$var$ChoreographerContext);

});
parcelRegister("lCnxw", function(module, exports) {

let $fbcf680e1bc5f2a6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fbcf680e1bc5f2a6$var$load("69dSh").then(()=>parcelRequire('fuev4'));

});


parcelRegister("kzyrP", function(module, exports) {

$parcel$export(module.exports, "StableContextProvider", () => $d8708472710e950a$export$d4982c0a28b18f63);

var $7UHDa = parcelRequire("7UHDa");

var $PAiZW = parcelRequire("PAiZW");
var $4H1Ql = parcelRequire("4H1Ql");

var $a8wvv = parcelRequire("a8wvv");
const $d8708472710e950a$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $4H1Ql.useStableObject)({
        ...(0, $a8wvv.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $PAiZW.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};

});

parcelRegister("goPQE", function(module, exports) {

$parcel$export(module.exports, "StablePlacementProvider", () => $2119b7887220da1c$export$e9fd288527498af6);

var $7UHDa = parcelRequire("7UHDa");

var $4H1Ql = parcelRequire("4H1Ql");

var $8Bzrf = parcelRequire("8Bzrf");
const $2119b7887220da1c$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $4H1Ql.useStableObject)(placement);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8Bzrf.PlacementProvider), {
        value: stableValue,
        children: children
    });
};

});
parcelRegister("8Bzrf", function(module, exports) {

$parcel$export(module.exports, "PlacementProvider", () => $d26f31a8de6bf192$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $d26f31a8de6bf192$export$4fc0446ee742ad80);

var $7UHDa = parcelRequire("7UHDa");

var $ffCOo = parcelRequire("ffCOo");

var $3Bn1T = parcelRequire("3Bn1T");

var $gwFzn = parcelRequire("gwFzn");
const $d26f31a8de6bf192$export$6394bf86db095a8 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    placementId: undefined
});
const $d26f31a8de6bf192$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $gwFzn.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $3Bn1T.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($d26f31a8de6bf192$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $d26f31a8de6bf192$export$4fc0446ee742ad80 = ()=>(0, $gwFzn.useContext)($d26f31a8de6bf192$export$6394bf86db095a8);

});
parcelRegister("3Bn1T", function(module, exports) {

$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $37d7f318e8260291$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $37d7f318e8260291$export$f51d04a086368016);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6sni0 = parcelRequire("6sni0");
const $37d7f318e8260291$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $37d7f318e8260291$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    placements: $37d7f318e8260291$var$initialPlacementState
});
const $37d7f318e8260291$export$70e19226ddeaf957 = ()=>(0, $gwFzn.useContext)($37d7f318e8260291$var$PostOfficeScreenContext);
const $37d7f318e8260291$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $37d7f318e8260291$export$5d27c0ee02be2a23 = ()=>(0, $gwFzn.useContext)($37d7f318e8260291$var$PostOfficeScreenUpdateContext);
const $37d7f318e8260291$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $gwFzn.useState)($37d7f318e8260291$var$initialPlacementState);
    const placementMount = (0, $gwFzn.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $6sni0.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $6sni0.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $gwFzn.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $gwFzn.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $gwFzn.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($37d7f318e8260291$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($37d7f318e8260291$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext,
            children: children
        })
    });
};
const $37d7f318e8260291$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $37d7f318e8260291$export$5d27c0ee02be2a23();
    (0, $gwFzn.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("6sni0", function(module, exports) {

$parcel$export(module.exports, "uniqueArray", () => $df02b7ceef3465b9$export$bbd17ecb0679edd7);
const $df02b7ceef3465b9$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});




parcelRegister("coAgb", function(module, exports) {

$parcel$export(module.exports, "StableRouteProvider", () => $ee97961d0a968e6e$export$ce13d00e696dfc96);

var $7UHDa = parcelRequire("7UHDa");

var $6yHRM = parcelRequire("6yHRM");
var $4H1Ql = parcelRequire("4H1Ql");

var $kbN4i = parcelRequire("kbN4i");
const $ee97961d0a968e6e$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $kbN4i.useLocationHref)();
    const stableRoute = (0, $4H1Ql.useStableObject)(route ?? {
        previous: href,
        current: href
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6yHRM.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};

});
parcelRegister("kbN4i", function(module, exports) {

$parcel$export(module.exports, "useLocationHref", () => $b036fb6e61b1c432$export$49fc3f3d8c7f99);
const $b036fb6e61b1c432$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $b036fb6e61b1c432$export$49fc3f3d8c7f99 = ()=>{
    return $b036fb6e61b1c432$var$isLocationAvailable() ? globalThis.location.href : undefined;
};

});



parcelRegister("2HRxT", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $efad4e1316fb199e$export$f0c7a449e0cfaec7);

var $7UHDa = parcelRequire("7UHDa");

var $7TH2w = parcelRequire("7TH2w");

var $7XIdu = parcelRequire("7XIdu");

var $c9VOQ = parcelRequire("c9VOQ");
const $efad4e1316fb199e$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $7UHDa.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c9VOQ.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation
            }, onError),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...data
            })
        });
    };

});
parcelRegister("c9VOQ", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $8da32cf6b910108b$export$e926676385687eaf);

var $gwFzn = parcelRequire("gwFzn");
'use client';
const $8da32cf6b910108b$export$b16d9fb1a22de840 = (0, $gwFzn.createContext)(null);
const $8da32cf6b910108b$var$initialState = {
    didCatch: false,
    error: null
};
class $8da32cf6b910108b$export$e926676385687eaf extends (0, $gwFzn.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($8da32cf6b910108b$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $8da32cf6b910108b$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($8da32cf6b910108b$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $gwFzn.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $gwFzn.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $gwFzn.createElement)($8da32cf6b910108b$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $8da32cf6b910108b$var$initialState;
    }
}
function $8da32cf6b910108b$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $8da32cf6b910108b$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $8da32cf6b910108b$export$c052f6604b7d51fe() {
    const context = (0, $gwFzn.useContext)($8da32cf6b910108b$export$b16d9fb1a22de840);
    $8da32cf6b910108b$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $gwFzn.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $gwFzn.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $8da32cf6b910108b$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $gwFzn.forwardRef)((props, ref)=>(0, $gwFzn.createElement)($8da32cf6b910108b$export$e926676385687eaf, errorBoundaryProps, (0, $gwFzn.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});




parcelRegister("2xYsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1916333c8b5a116e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $1DWH0 = parcelRequire("1DWH0");

var $gwFzn = parcelRequire("gwFzn");
class $1916333c8b5a116e$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
var $1916333c8b5a116e$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($1916333c8b5a116e$var$ErrorBoundary);

});

parcelRegister("hnA4H", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $f3b0e253e752d4df$export$85183a312807388d);
const $f3b0e253e752d4df$export$85183a312807388d = 'postOffice';

});


parcelRegister("cyz5M", function(module, exports) {

$parcel$export(module.exports, "MaybeSuspenseBoundary", () => $765afc5340447923$export$9750eb54d7c7e789);
$parcel$export(module.exports, "asMessageRenderer", () => $765afc5340447923$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $7UHDa = parcelRequire("7UHDa");

var $c6GJD = parcelRequire("c6GJD");

var $4H1Ql = parcelRequire("4H1Ql");

var $3NyPa = parcelRequire("3NyPa");
var $h6POP = parcelRequire("h6POP");

var $hOVIX = parcelRequire("hOVIX");

var $3Shv6 = parcelRequire("3Shv6");

var $2amyA = parcelRequire("2amyA");
var $aEUWC = parcelRequire("aEUWC");
var $jVzfH = parcelRequire("jVzfH");
var $fUB5z = parcelRequire("fUB5z");
var $2HRxT = parcelRequire("2HRxT");

var $hyvHs = parcelRequire("hyvHs");

var $gwFzn = parcelRequire("gwFzn");

var $lVEBn = parcelRequire("lVEBn");
const $765afc5340447923$var$STABLE_EMPTY_OBJECT = {};
const $765afc5340447923$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        ...props,
        children: children
    });
};
const $765afc5340447923$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $gwFzn.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, SuspenseBoundary: SuspenseBoundary = (0, $gwFzn.Suspense), ...data })=>{
            const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
            const recommendationSessionStable = (0, $4H1Ql.useStableObject)(recommendationSession ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT);
            const postOfficeStable = (0, $4H1Ql.useStableObject)(postOffice ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT);
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $gwFzn.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $3NyPa.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fUB5z.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $gwFzn.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $hOVIX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $hOVIX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $gwFzn.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                        name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                        children: loadingFallback ?? null
                    }), [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                const componentPropsStable = (0, $4H1Ql.useStableObject)(componentProps);
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return (0, $c6GJD.default).checkGate('po-refactor-message-renderer-provider') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jVzfH.MessageRendererProvider), {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    recommendationSession: recommendationSessionStable === $765afc5340447923$var$STABLE_EMPTY_OBJECT ? undefined : recommendationSessionStable,
                    messageSuccessComponent: messageSuccessComponent,
                    componentProps: componentPropsStable,
                    loadingFallback: loadingFallback,
                    triggerId: triggerId,
                    messageCreationType: messageCreationType,
                    postOffice: postOfficeStable,
                    isUFOEnabled: isUFOEnabled,
                    SuspenseBoundary: SuspenseBoundary,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                        onError: onError,
                        ...componentProps
                    })
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lVEBn.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Shv6.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                triggerId: triggerId,
                                messageCreationType: messageCreationType,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails,
                                journeyId: journeyId,
                                journeyTriggerId: journeyTriggerId
                            },
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hyvHs.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aEUWC.MessageAnalyticsContextProvider), {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                                                onError: onError,
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $2HRxT.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};

});
parcelRegister("hOVIX", function(module, exports) {

$parcel$export(module.exports, "PostOfficeErrorCodes", () => $0a8f0e83dcf5160a$export$b9722560029694e7);
$parcel$export(module.exports, "PostOfficeError", () => $0a8f0e83dcf5160a$export$d145ea5319863172);
$parcel$export(module.exports, "InvalidMessageTemplateIdError", () => $0a8f0e83dcf5160a$export$19cb89dd679394cb);
$parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", () => $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d);
var $0a8f0e83dcf5160a$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["HandlerValidationError"] = "HandlerValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["UnsupportedEmailError"] = "UnsupportedEmailError";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 extends Error {
}
class $0a8f0e83dcf5160a$export$627bc00a5ef5f6ae extends Error {
}
class $0a8f0e83dcf5160a$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $0a8f0e83dcf5160a$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $0a8f0e83dcf5160a$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $0a8f0e83dcf5160a$export$ed601cd0dc1a1be7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(args){
        super('Error in message template code', "MessageTemplateError", args.cause);
        this.function = void 0;
        this.messageTemplateId = void 0;
        this.triggerId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8d39b103586e9fd4 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "NotAbleToProcessEmailTemplateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$f649da38897d27f7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c2852c1c4d9aba3e extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4b7b4e09547e4bb3 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$360a094a97597d87 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4d068b43eb55165b extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ac007ee150add337 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$b79ba63f8ae791e0 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(errorCause){
        super('Invalid event, encountered validation errors in handler', "HandlerValidationError", errorCause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$19cb89dd679394cb extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$78651662ad470cc5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8a5041670cdd8db2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Journey not found', "JourneyNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1240ddc25cf964e6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3c4884b7ae7fe517 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$913b8e68dc7ae8fe extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e5ccdf8bbfead7a2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$823733742d803ae6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1caa32527f23acd2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.errorCause = void 0;
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$a6f2aad8fa094b39 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(accountId){
        super('Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2f1e27130c2bf271 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.payloadSize = void 0;
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$d0dc094613469f2b extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.workspaceId = void 0;
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$5603eab37ce562f5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.fileType = void 0;
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$b35ca1cf49054efc extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, email){
        super(message, "UnsupportedEmailError");
        this.email = void 0;
        this.name = this.constructor.name;
        this.email = email;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e0e9aa0e9c6b37ff extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.error = void 0;
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3ad818f64601e141 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$25470bb6cba4fba0 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.messageTemplateId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ce14d445679448b6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.messageTemplateId = void 0;
        this.messageInstanceId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $0a8f0e83dcf5160a$export$c9a26a17db1045c8 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8ab4fb362168b928 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2afd69f57fe5285f extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$7635d2b1a281d626 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = void 0;
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$9e1c6d00e675bc86 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.recipient = void 0;
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$6d1a4929f6ff1a32 extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = void 0;
        this.messageInstanceId = void 0;
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$c504492f06c975b5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.ipmNumber = void 0;
        this.variantFromStatsig = void 0;
        this.contentfulLocale = void 0;
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}

});

parcelRegister("3Shv6", function(module, exports) {

$parcel$export(module.exports, "MessageContextProvider", () => $f1cd061039c521e8$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $f1cd061039c521e8$export$a5b6d14a2e25725a);

var $gwFzn = parcelRequire("gwFzn");
const $f1cd061039c521e8$var$initialValue = {};
const $f1cd061039c521e8$export$b060d577040138d8 = (0, $gwFzn.createContext)($f1cd061039c521e8$var$initialValue);
const $f1cd061039c521e8$export$42de33f7652dc3de = $f1cd061039c521e8$export$b060d577040138d8.Provider;
const $f1cd061039c521e8$export$a5b6d14a2e25725a = ()=>(0, $gwFzn.useContext)($f1cd061039c521e8$export$b060d577040138d8);

});

parcelRegister("2amyA", function(module, exports) {

$parcel$export(module.exports, "FeatureFlaggedUfoWrapper", () => $5a78db0628042bee$export$8e6fb7035018b3e4);

var $7UHDa = parcelRequire("7UHDa");

var $h6POP = parcelRequire("h6POP");
const $5a78db0628042bee$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});

parcelRegister("aEUWC", function(module, exports) {

$parcel$export(module.exports, "MessageAnalyticsContextProvider", () => $03b25510c5956e6e$export$1737ab199e83455e);
$parcel$export(module.exports, "useMessageAnalyticsContext", () => $03b25510c5956e6e$export$bb426ba114b64992);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $03b25510c5956e6e$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $03b25510c5956e6e$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $gwFzn.createContext)($03b25510c5956e6e$var$defaultMessageAnalyticsContextValue);
const $03b25510c5956e6e$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $gwFzn.useRef)(false);
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($03b25510c5956e6e$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $03b25510c5956e6e$export$bb426ba114b64992 = ()=>(0, $gwFzn.useContext)($03b25510c5956e6e$export$c81717973c6c4a90);

});

parcelRegister("jVzfH", function(module, exports) {

$parcel$export(module.exports, "MessageRendererProvider", () => $121622f1adade9d3$export$5fe06fe68913d493);

var $7UHDa = parcelRequire("7UHDa");

var $h6POP = parcelRequire("h6POP");

var $3Shv6 = parcelRequire("3Shv6");

var $hyvHs = parcelRequire("hyvHs");

var $gwFzn = parcelRequire("gwFzn");

var $5RZ3F = parcelRequire("5RZ3F");

var $2amyA = parcelRequire("2amyA");

var $aEUWC = parcelRequire("aEUWC");
const $121622f1adade9d3$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $121622f1adade9d3$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $gwFzn.Suspense) })=>{
    const loadingComponent = (0, $gwFzn.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
            name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $gwFzn.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            componentProps: componentProps,
            postOffice: postOffice
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps,
        postOffice
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5RZ3F.ChoreographerWrapper), {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Shv6.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hyvHs.RecommendationProvider), {
                    value: recommendationSession ?? $121622f1adade9d3$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aEUWC.MessageAnalyticsContextProvider), {
                            children: [
                                messageSuccessComponent,
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("hyvHs", function(module, exports) {

$parcel$export(module.exports, "RecommendationProvider", () => $68ebcc2083a05cc4$export$f60e87d7b5f59562);
$parcel$export(module.exports, "useRecommendationContext", () => $68ebcc2083a05cc4$export$3321c0b02f750bcc);

var $7UHDa = parcelRequire("7UHDa");

var $bYRk6 = parcelRequire("bYRk6");

var $gwFzn = parcelRequire("gwFzn");
const $68ebcc2083a05cc4$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $68ebcc2083a05cc4$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($68ebcc2083a05cc4$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
            data: value,
            children: children
        })
    });
};
const $68ebcc2083a05cc4$export$3321c0b02f750bcc = ()=>(0, $gwFzn.useContext)($68ebcc2083a05cc4$export$ba2f44035effd9c1);

});

parcelRegister("5RZ3F", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $92519f251282f573$export$8db7ba034addcd65);

var $7UHDa = parcelRequire("7UHDa");

var $c6GJD = parcelRequire("c6GJD");

var $7XIdu = parcelRequire("7XIdu");

var $gwFzn = parcelRequire("gwFzn");

var $3zCGc = parcelRequire("3zCGc");
const $92519f251282f573$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return null;
};
const $92519f251282f573$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3zCGc.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $7UHDa.jsx)($92519f251282f573$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});


parcelRegister("lVEBn", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $5d2b57d7f45b3b6a$export$8db7ba034addcd65);

var $7UHDa = parcelRequire("7UHDa");

var $c6GJD = parcelRequire("c6GJD");

var $7XIdu = parcelRequire("7XIdu");

var $3zCGc = parcelRequire("3zCGc");

var $gwFzn = parcelRequire("gwFzn");
const $5d2b57d7f45b3b6a$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return null;
};
const $5d2b57d7f45b3b6a$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3zCGc.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $7UHDa.jsx)($5d2b57d7f45b3b6a$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});


parcelRegister("6Ht9d", function(module, exports) {

$parcel$export(module.exports, "useInitialData", () => $876859b1b10b173e$export$5523c5f3222291d0);

var $gwFzn = parcelRequire("gwFzn");

var $gAOec = parcelRequire("gAOec");
const $876859b1b10b173e$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $gwFzn.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $gAOec.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});
parcelRegister("gAOec", function(module, exports) {

$parcel$export(module.exports, "AlreadyRunningError", () => $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b);
$parcel$export(module.exports, "useData", () => $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937);

var $7XIdu = parcelRequire("7XIdu");

var $2UZs0 = parcelRequire("2UZs0");

var $gwFzn = parcelRequire("gwFzn");

var $6IMPA = parcelRequire("6IMPA");
class $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $gwFzn.useState)((0, $6IMPA.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $gwFzn.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then((0, $6IMPA.assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
            setState((0, $6IMPA.toData)(data));
            fireAnalyticsEvent({
                action: 'resolved',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $2UZs0.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes
                }
            });
        }).catch((err)=>{
            if (err instanceof $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $6IMPA.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $2UZs0.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};

});
parcelRegister("6IMPA", function(module, exports) {

$parcel$export(module.exports, "assertResponseIsOk", () => $7d79f12ff0021e5f$export$b3732c8ff6f9c463);
$parcel$export(module.exports, "toLoading", () => $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc);
$parcel$export(module.exports, "toError", () => $7d79f12ff0021e5f$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "toData", () => $7d79f12ff0021e5f$export$24a6b176bdc41ce5);
const $7d79f12ff0021e5f$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $7d79f12ff0021e5f$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($7d79f12ff0021e5f$export$18a0019e5439b209(res));
};
const $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $7d79f12ff0021e5f$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $7d79f12ff0021e5f$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });

});



parcelRegister("cm2rU", function(module, exports) {

$parcel$export(module.exports, "default", () => $60de571a416785ce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable formatjs/no-literal-string-in-jsx */ /* eslint-disable no-restricted-imports */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $c6GJD = parcelRequire("c6GJD");

var $ar661 = parcelRequire("ar661");

var $PAiZW = parcelRequire("PAiZW");

var $lfQiY = parcelRequire("lfQiY");

var $fJvXe = parcelRequire("fJvXe");
var $hRQgD = parcelRequire("hRQgD");
var $6FJLn = parcelRequire("6FJLn");

var $2YerA = parcelRequire("2YerA");

var $7XIdu = parcelRequire("7XIdu");

var $4nMma = parcelRequire("4nMma");

var $2mPpz = parcelRequire("2mPpz");
var $6Ht9d = parcelRequire("6Ht9d");

var $4jR19 = parcelRequire("4jR19");

var $9qPN0 = parcelRequire("9qPN0");

var $lFxsG = parcelRequire("lFxsG");

var $kaNhw = parcelRequire("kaNhw");

var $ePT1r = parcelRequire("ePT1r");
const $60de571a416785ce$var$adminSwitcherItemStyle = null;
const $60de571a416785ce$var$discoverMoreProductsTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
    id: "app-switcher-discovery-section.discover-more-products",
    defaultMessage: "Discover more apps"
});
const $60de571a416785ce$var$recommendedForYourTeamTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
    id: "app-switcher-discovery-section.recommended-for-your-team",
    defaultMessage: "Recommended for your team"
});
const $60de571a416785ce$var$moreAtlassianProducts = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
    id: "app-switcher-discovery-section.more-atlassian-products",
    defaultMessage: "More Atlassian apps"
});
const $60de571a416785ce$var$CROSS_FLOW_SOURCE_COMPONENT = 'atlassian-switcher';
const $60de571a416785ce$var$CROSS_FLOW_SOURCE_CONTEXT = 'more';
const $60de571a416785ce$var$PLACEMENT_ID = 'app-switcher-discovery-section'; // Jira Local Consumption - MessageRenderer is typed as 'React.FC<any>' as otherwise it fails typecheck within Jira with the below error:
const $60de571a416785ce$export$2df1250b8f917a59 = (0, $kaNhw.initializeMessageRenderer)();
const $60de571a416785ce$export$6b2f07b528cc1aa5 = (0, $ePT1r.withAppSwitcherDiscoverySectionIntlProvider)((0, $2mPpz.createPlacementComponent)($60de571a416785ce$var$PLACEMENT_ID, ({ initialData: initialData, extraAnalyticsAttributes: extraAnalyticsAttributes })=>{
    const initialDataState = (0, $6Ht9d.useInitialData)(initialData);
    const crossFlow = (0, $2YerA.useCrossFlow)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const isInWacContext = (0, $4nMma.useIsWacContext)();
    const handleClickMoreAtlassianProducts = (0, $gwFzn.useCallback)(async ()=>{
        if (crossFlow.isEnabled) {
            fireAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'listItem',
                actionSubjectId: 'discoverMoreAtlassianProductsButton'
            });
            await crossFlow.api.open({
                journey: (0, $2YerA.Journeys).DISCOVER,
                sourceComponent: $60de571a416785ce$var$CROSS_FLOW_SOURCE_COMPONENT,
                sourceContext: $60de571a416785ce$var$CROSS_FLOW_SOURCE_CONTEXT
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [dismissedMessageInstanceIds, setDismissedMessageInstanceIds] = (0, $gwFzn.useState)([]);
    const { dismissedMessageIds: dismissedMessageIds, showFlag: showFlag, handleDismissFlag: handleDismissFlag } = (0, $9qPN0.useProductDismissalFlag)();
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $lfQiY.useFireCrossFlowAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $PAiZW.usePostOfficeContext)();
    const handleOnDismissed = (0, $gwFzn.useCallback)((dismissedMessageInstanceId)=>{
        setDismissedMessageInstanceIds([
            ...dismissedMessageInstanceIds,
            dismissedMessageInstanceId
        ]);
        showFlag(dismissedMessageInstanceId);
    }, [
        dismissedMessageInstanceIds,
        showFlag
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (initialDataState.data?.messages) {
            const productIds = initialDataState.data.messages.map((message)=>$60de571a416785ce$var$getProductIdFromMessageTemplateId(message.messageTemplateId)).filter(Boolean);
            fireViewedUIEvent({
                action: 'viewed',
                actionSubject: 'section',
                actionSubjectId: 'atlassianSwitcherDiscoverProducts'
            }, {
                source: 'atlassianSwitcherDiscoverProductsSection',
                recommendedProductIds: productIds
            }, {
                isSiteAdmin: isSiteAdmin
            });
        }
    }, [
        fireViewedUIEvent,
        initialDataState.data?.messages,
        isSiteAdmin
    ]);
    if (initialDataState.error) return null;
    if (initialDataState.isLoading) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hRQgD.default), {});
    const messages = initialDataState?.data.messages;
    const messagesWithoutDismissed = messages.filter((message)=>!dismissedMessageInstanceIds.includes(message.messageInstanceId));
    const decideTitle = ()=>{
        if (isInWacContext && messagesWithoutDismissed.length === 0) return null;
        return messagesWithoutDismissed.length > 0 ? $60de571a416785ce$var$recommendedForYourTeamTitle : $60de571a416785ce$var$discoverMoreProductsTitle;
    };
    const title = decideTitle(); // GALILEO-1402 START
    // check if there is a recommendation for JSM or JPD
    const hasJsmOrJpdRecommendation = messagesWithoutDismissed.some((message)=>message.messageTemplateId === 'recommendation-jsm' || message.messageTemplateId === 'recommendation-jpd'); // Fire exposure event ONLY if there is a recommendation for JSM or JPD
    hasJsmOrJpdRecommendation && (0, $c6GJD.default).getExperimentValue('recommend_templates_from_switcher_for_jpd_and_jsm', 'recommendation', 'product'); // GALILEO-1402 END
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fJvXe.SectionContainer), {
        sectionId: "discover",
        title: title,
        children: [
            messagesWithoutDismissed.map((message)=>/*#__PURE__*/ (0, $7UHDa.jsx)($60de571a416785ce$export$2df1250b8f917a59, {
                    ...message,
                    onDismissed: handleOnDismissed,
                    loadingFallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lFxsG.SwitcherSkeletonItem), {}),
                    extraAnalyticsAttributes: extraAnalyticsAttributes
                }, message.messageInstanceId)),
            isInWacContext ? null : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FJLn.default), {
                onClick: handleClickMoreAtlassianProducts,
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                    className: (0, $35pXk.default)([
                        "_2rkopd34 _1reo15vq _18m915vq _bfhkm7j4 _syaz131l _1e0c1txw _1bsbxy5q _4t3ixy5q _4cvr1h6o _1bah1h6o"
                    ]),
                    children: (0, $ar661.MoreAtlassianAppsIcon)({
                        label: 'Discover More',
                        size: '32',
                        testId: 'app-switcher-discover-more-section__icon'
                    })
                }),
                children: $60de571a416785ce$var$moreAtlassianProducts
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9qPN0.ProductDismissalFlag), {
                dismissedMessageIds: dismissedMessageIds,
                handleDismissFlag: handleDismissFlag
            })
        ]
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    }
}));
const $60de571a416785ce$var$MESSAGE_TEMPLATE_ID_TO_PRODUCT_ID_MAP = {
    'recommendation-atlas': '7c917705-866d-4b6b-b266-0fc7633e8342',
    'recommendation-confluence': '6aab3f4e-cc71-474d-8d28-abef8b057808',
    'recommendation-jpd': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    'recommendation-jsm': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    'recommendation-jsw': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    'recommendation-jwm': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    'recommendation-loom': '7683a73e-423d-41a1-b43f-d497656f8b5d',
    'recommendation-opsgenie': 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    'recommendation-rovo': '91ae3e3f-138e-43be-98cc-48df03d13c32'
}; // This is a temporary mapping for this placement to contribute to go/crossflowfunnel
// It will be fixed in the future by updating the dashboard to read directly from PO analytics
const $60de571a416785ce$var$getProductIdFromMessageTemplateId = (messageTemplateId)=>{
    return $60de571a416785ce$var$MESSAGE_TEMPLATE_ID_TO_PRODUCT_ID_MAP[messageTemplateId];
};
var $60de571a416785ce$export$2e2bcd8739ae039 = $60de571a416785ce$export$6b2f07b528cc1aa5;

});
parcelRegister("ar661", function(module, exports) {

$parcel$export(module.exports, "MoreAtlassianAppsIcon", () => $33cdae2480d331a9$export$518f48548316ec87);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c121b580272220c77ea1ac97d4fc91c3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7JAtv = parcelRequire("7JAtv");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $33cdae2480d331a9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z"/>
</svg>
`;
function $33cdae2480d331a9$export$518f48548316ec87({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7JAtv.IconWrapper), {
        svg: $33cdae2480d331a9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4nMma", function(module, exports) {

$parcel$export(module.exports, "useIsWacContext", () => $0732a3e86f92a543$export$4e9304272964deb6);

var $PAiZW = parcelRequire("PAiZW");

var $27tbl = parcelRequire("27tbl");
const $0732a3e86f92a543$export$4e9304272964deb6 = ()=>{
    const context = (0, $PAiZW.usePostOfficeContext)();
    return context.product === (0, $27tbl.productNames).WAC;
};
const $0732a3e86f92a543$export$631ba87ff5b9e288 = (microsEnvType)=>{
    switch(microsEnvType){
        case 'dev':
            return 'https://admin.dev.atlassian.com';
        case 'staging':
            return 'https://admin.stg.atlassian.com';
        default:
            return 'https://admin.atlassian.com';
    }
};

});
parcelRegister("27tbl", function(module, exports) {

$parcel$export(module.exports, "productNames", () => $e815e8986f234c20$export$55ed4fa25efa6fad);
const $e815e8986f234c20$export$55ed4fa25efa6fad = {
    WAC: 'marketing'
};
const $e815e8986f234c20$export$40cd2d71062b3400 = 'segment_confluence_mau_not_mcu_with_user_tenure_greater_than_90_days_siteuser';
const $e815e8986f234c20$export$f9ae93b6f9702050 = 'post-office_expt_confluence-comments-nudge';

});


parcelRegister("9qPN0", function(module, exports) {

$parcel$export(module.exports, "ProductDismissalFlag", () => $75181cea81fbaddd$export$a309243da00b18dc);
$parcel$export(module.exports, "useProductDismissalFlag", () => $75181cea81fbaddd$export$887afb916153c3fb);

var $7UHDa = parcelRequire("7UHDa");

var $aD1SW = parcelRequire("aD1SW");
var $6uGcC = parcelRequire("6uGcC");

var $eCByP = parcelRequire("eCByP");

var $6fnsQ = parcelRequire("6fnsQ");

var $7XIdu = parcelRequire("7XIdu");

var $4nMma = parcelRequire("4nMma");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $jLfBr = parcelRequire("jLfBr");

var $6I9AF = parcelRequire("6I9AF");
// /**--Title--**/
const $75181cea81fbaddd$var$Title = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        id: "growth.app-switcher-discovery-section.flag.title",
        defaultMessage: "Got it, thanks for letting us know"
    });
// /**--Description--**/
const $75181cea81fbaddd$var$Description = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        id: "growth.app-switcher-discovery-section.flag.description",
        defaultMessage: "You won\u2019t see this here as often."
    });
const $75181cea81fbaddd$export$a309243da00b18dc = ({ dismissedMessageIds: dismissedMessageIds, handleDismissFlag: handleDismissFlag })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const isInWacContext = (0, $4nMma.useIsWacContext)();
    const onDismissed = (messageId)=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsFlagClose'
        });
        handleDismissFlag(messageId);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
        children: dismissedMessageIds.map((messageId)=>isInWacContext ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jLfBr.WacToast), {
                title: /*#__PURE__*/ (0, $7UHDa.jsx)($75181cea81fbaddd$var$Title, {}),
                description: /*#__PURE__*/ (0, $7UHDa.jsx)($75181cea81fbaddd$var$Description, {}),
                onDismissed: ()=>onDismissed(messageId)
            }, messageId) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aD1SW.default), {
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eCByP))), {
                    primaryColor: `var(--ds-icon-success, ${$6fnsQ.G400})`,
                    label: "Success"
                }),
                description: /*#__PURE__*/ (0, $7UHDa.jsx)($75181cea81fbaddd$var$Description, {}),
                id: messageId,
                title: /*#__PURE__*/ (0, $7UHDa.jsx)($75181cea81fbaddd$var$Title, {}),
                appearance: 'normal',
                onDismissed: ()=>onDismissed(messageId)
            }, messageId))
    });
};
const $75181cea81fbaddd$export$887afb916153c3fb = ()=>{
    const [dismissedMessageIds, setDismissedMessageIds] = (0, $gwFzn.useState)([]);
    return {
        dismissedMessageIds: dismissedMessageIds,
        showFlag: (dismissedMessageId)=>setDismissedMessageIds((current)=>[
                    ...current,
                    dismissedMessageId
                ]),
        handleDismissFlag: (dismissedMessageId)=>setDismissedMessageIds((0, $6I9AF.removeMessage)(dismissedMessageId))
    };
};

});
parcelRegister("jLfBr", function(module, exports) {

$parcel$export(module.exports, "WacToast", () => $990856b2b017a9e4$export$df43802f8a343160);
/* wac-toast.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ge0Ua = parcelRequire("ge0Ua");

var $dBxQj = parcelRequire("dBxQj");
const $990856b2b017a9e4$var$mainContainerStyle = null;
const $990856b2b017a9e4$var$closedToastStyle = null;
const $990856b2b017a9e4$var$contentSectionStyle = null;
const $990856b2b017a9e4$var$imageSectionStyle = null;
const $990856b2b017a9e4$var$showToastAnimationStyle = null;
const $990856b2b017a9e4$var$titleStyle = null;
const $990856b2b017a9e4$var$descriptionStyle = null;
const $990856b2b017a9e4$var$closePanelIconContainerStyle = null;
const $990856b2b017a9e4$export$df43802f8a343160 = (props)=>{
    const { title: title, description: description, onDismissed: onDismissed } = props;
    const [shouldAnimate, setShouldAnimate] = (0, $gwFzn.useState)(false);
    const [isClosed, setIsClosed] = (0, $gwFzn.useState)(false);
    const intl = (0, $dBxQj.default)();
    const dismissToastAriaLabel = intl.formatMessage({
        id: "growth.app-switcher-discovery-section.wac-toast.close.aria-label",
        defaultMessage: "Dismiss toast"
    });
    (0, $gwFzn.useEffect)(()=>{
        setTimeout(()=>{
            setShouldAnimate(true);
        }, 100);
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        // auto dismiss
        setTimeout(()=>{
            closeToastCard();
        }, 8000);
    }, []);
    const closeToastCard = ()=>{
        setIsClosed(true);
    };
    const handleOnCloseClick = ()=>{
        closeToastCard();
        setTimeout(()=>{
            onDismissed && onDismissed();
        }, 800);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            "_2rko1b66 _tzy4idpf _16qs1nta _1bsb1178 _bfhkvuon _t9ec1pmk _1qza1osq _1mrf17un",
            shouldAnimate && "_v56413jc _tzy4kb7n _t9ec1kli _1mrfvg6r",
            isClosed && "_v564wlka _tzy4idpf _t9ec1o0r _1qza1osq _1mrf1jum"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
            className: (0, $35pXk.default)([
                "_2rko1b66 _1yt41ejb _1e0c1txw _2lx21bp4 _bfhkvuon _y3gn1e5h"
            ]),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                    className: (0, $35pXk.default)([
                        "_1e0c1txw _2lx2vrvc _1bah1yb4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)($990856b2b017a9e4$var$SuccessIcon, {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("button", {
                            id: "toast-close-button",
                            onClick: handleOnCloseClick,
                            "aria-label": dismissToastAriaLabel,
                            className: (0, $35pXk.default)([
                                "_bfhk18uv _19itidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ge0Ua))), {
                                label: dismissToastAriaLabel,
                                size: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("h3", {
                    className: (0, $35pXk.default)([
                        "_k48p1nn1 _vwz43ei5 _ect41kw7 _1wyb1k8s _19pkpxbi _otyru2gc"
                    ]),
                    children: title
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("p", {
                    className: (0, $35pXk.default)([
                        "_18s81bpf"
                    ]),
                    children: description
                })
            ]
        })
    });
};
const $990856b2b017a9e4$var$SuccessIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM27.8668 16.2282C28.4316 15.6086 28.4144 14.648 27.8154 14.049L27.7617 13.9977C27.142 13.4329 26.1815 13.45 25.5825 14.049L17.2709 22.3606L14.4176 19.5074L14.3639 19.4561C13.7442 18.8913 12.7837 18.9084 12.1847 19.5074C11.568 20.124 11.568 21.1237 12.1847 21.7404L16.1544 25.7101L16.2082 25.7614C16.8278 26.3262 17.7883 26.3091 18.3873 25.7101L27.8154 16.282L27.8668 16.2282Z",
            fill: "#82B536"
        })
    });

});

parcelRegister("6I9AF", function(module, exports) {

$parcel$export(module.exports, "removeMessage", () => $8d3e387dfec25223$export$f9a3c275d8ffdac0);
const $8d3e387dfec25223$export$f9a3c275d8ffdac0 = (messageId)=>(currentMessageIds)=>currentMessageIds.filter((id)=>id !== messageId);

});


parcelRegister("lFxsG", function(module, exports) {

$parcel$export(module.exports, "SwitcherSkeletonItem", () => $2e1ba8ce904738f1$export$d281ba7ce1dcaa47);
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $lYygP = parcelRequire("lYygP");
const $2e1ba8ce904738f1$var$iconSkeletonStyles = null;
const $2e1ba8ce904738f1$var$lineSkeletonStyles = null;
const $2e1ba8ce904738f1$var$iconSkeleton = /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
    className: (0, $35pXk.default)([
        "_2rkopd34 _1e0c1o8l _1bsbzwfg _4t3izwfg _bfhkn82g"
    ])
});
const $2e1ba8ce904738f1$var$lineSkeleton = /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
    className: (0, $35pXk.default)([
        "_2rko1sit _1e0c1o8l _1bsb1uc6 _4t3i19bv _bfhkn82g"
    ])
}); // TODO: Export this as a primitive from Switcher instead of creating it here
const $2e1ba8ce904738f1$export$d281ba7ce1dcaa47 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lYygP.default), {
        tag: "li",
        icon: $2e1ba8ce904738f1$var$iconSkeleton,
        isDisabled: true,
        children: $2e1ba8ce904738f1$var$lineSkeleton
    });
};

});

parcelRegister("kaNhw", function(module, exports) {

$parcel$export(module.exports, "initializeMessageRenderer", () => $1747fe69d2df31f5$export$bce4e5106d86e473);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $cyz5M = parcelRequire("cyz5M");

var $beAnL = parcelRequire("beAnL");

var $fVDar = parcelRequire("fVDar");

var $lTT56 = parcelRequire("lTT56");

var $cOelw = parcelRequire("cOelw");
const $1747fe69d2df31f5$export$e30378e28ad3e6ab = {
    ...(0, $beAnL.default),
    ...(0, $fVDar.default),
    ...(0, $lTT56.default),
    ...(0, $cOelw.default)
};
const { initializeMessageRenderer: $1747fe69d2df31f5$export$bce4e5106d86e473, MessageRenderer: $1747fe69d2df31f5$export$2df1250b8f917a59 } = (0, $cyz5M.asMessageRenderer)($1747fe69d2df31f5$export$e30378e28ad3e6ab);

});
parcelRegister("beAnL", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c16971a334a19d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");









var $05c16971a334a19d$export$2e2bcd8739ae039 = {
    'recommendation-atlas': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("kFU7y"))),
    'recommendation-confluence': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hnTik"))),
    'recommendation-jpd': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2uV09"))),
    'recommendation-jsm': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6wC2S"))),
    'recommendation-jsw': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fA5HM"))),
    'recommendation-jsw-dynamic-description': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("fHXkf"))),
    'recommendation-jwm': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("lytjQ"))),
    'recommendation-loom': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("7A9wK"))),
    'recommendation-opsgenie': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3UV5r")))
};

});
parcelRegister("kFU7y", function(module, exports) {

let $f0d32b68c7c4b5b8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f0d32b68c7c4b5b8$var$load("ct3kN"),
    $f0d32b68c7c4b5b8$var$load("8gQKz"),
    $f0d32b68c7c4b5b8$var$load("ctZCD"),
    $f0d32b68c7c4b5b8$var$load("7Q0UC"),
    $f0d32b68c7c4b5b8$var$load("6m2wP")
]).then(()=>parcelRequire('h3wNo'));

});

parcelRegister("hnTik", function(module, exports) {

let $ca7f7a041a0cbe73$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ca7f7a041a0cbe73$var$load("8gQKz"),
    $ca7f7a041a0cbe73$var$load("ctZCD"),
    $ca7f7a041a0cbe73$var$load("7Q0UC"),
    $ca7f7a041a0cbe73$var$load("gopxm")
]).then(()=>parcelRequire('1BKEb'));

});

parcelRegister("2uV09", function(module, exports) {

let $1d1a99641567d310$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1d1a99641567d310$var$load("ct3kN"),
    $1d1a99641567d310$var$load("8gQKz"),
    $1d1a99641567d310$var$load("ctZCD"),
    $1d1a99641567d310$var$load("7Q0UC"),
    $1d1a99641567d310$var$load("9N316")
]).then(()=>parcelRequire('4cOCK'));

});

parcelRegister("6wC2S", function(module, exports) {

let $4c033e3f1a009ea2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4c033e3f1a009ea2$var$load("ct3kN"),
    $4c033e3f1a009ea2$var$load("8gQKz"),
    $4c033e3f1a009ea2$var$load("ctZCD"),
    $4c033e3f1a009ea2$var$load("7Q0UC"),
    $4c033e3f1a009ea2$var$load("603iI")
]).then(()=>parcelRequire('jGNAq'));

});

parcelRegister("fA5HM", function(module, exports) {

let $b57ea4b59ab42267$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b57ea4b59ab42267$var$load("ct3kN"),
    $b57ea4b59ab42267$var$load("8gQKz"),
    $b57ea4b59ab42267$var$load("ctZCD"),
    $b57ea4b59ab42267$var$load("7Q0UC"),
    $b57ea4b59ab42267$var$load("dVwBo")
]).then(()=>parcelRequire('hLkI7'));

});

parcelRegister("fHXkf", function(module, exports) {

let $b6f8e3f8f15bbdcd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b6f8e3f8f15bbdcd$var$load("ct3kN"),
    $b6f8e3f8f15bbdcd$var$load("8gQKz"),
    $b6f8e3f8f15bbdcd$var$load("ctZCD"),
    $b6f8e3f8f15bbdcd$var$load("7Q0UC"),
    $b6f8e3f8f15bbdcd$var$load("ipxYo")
]).then(()=>parcelRequire('6h9cg'));

});

parcelRegister("lytjQ", function(module, exports) {

let $fb13841d651aafa3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fb13841d651aafa3$var$load("ct3kN"),
    $fb13841d651aafa3$var$load("8gQKz"),
    $fb13841d651aafa3$var$load("ctZCD"),
    $fb13841d651aafa3$var$load("7Q0UC"),
    $fb13841d651aafa3$var$load("l37ax")
]).then(()=>parcelRequire('7Z4Bp'));

});

parcelRegister("7A9wK", function(module, exports) {

let $5853491f5c378da5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5853491f5c378da5$var$load("ct3kN"),
    $5853491f5c378da5$var$load("8gQKz"),
    $5853491f5c378da5$var$load("ctZCD"),
    $5853491f5c378da5$var$load("7Q0UC"),
    $5853491f5c378da5$var$load("ntv3W")
]).then(()=>parcelRequire('itIol'));

});

parcelRegister("3UV5r", function(module, exports) {

let $2da2e24804d207fc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2da2e24804d207fc$var$load("ct3kN"),
    $2da2e24804d207fc$var$load("8gQKz"),
    $2da2e24804d207fc$var$load("ctZCD"),
    $2da2e24804d207fc$var$load("7Q0UC"),
    $2da2e24804d207fc$var$load("1b5ye")
]).then(()=>parcelRequire('mhFvJ'));

});


parcelRegister("fVDar", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d3eaf535df8ab6d$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $2d3eaf535df8ab6d$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("dFvFh")))
};

});
parcelRegister("dFvFh", function(module, exports) {

let $9f37aaac91a3257e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9f37aaac91a3257e$var$load("ctZCD"),
    $9f37aaac91a3257e$var$load("eEBx4")
]).then(()=>parcelRequire('cuPHJ'));

});


parcelRegister("lTT56", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c81a61d7d05374f$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");



var $9c81a61d7d05374f$export$2e2bcd8739ae039 = {
    'test-message-inapp': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("6PFqF"))),
    'test-message-inapp-engagement': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("2TXSI"))),
    'test-message-marketing': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("5rpc8")))
};

});
parcelRegister("6PFqF", function(module, exports) {

let $4f97a47693e48a2a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4f97a47693e48a2a$var$load("ctZCD"),
    $4f97a47693e48a2a$var$load("f7nCb")
]).then(()=>parcelRequire('4xvKn'));

});

parcelRegister("2TXSI", function(module, exports) {

let $21cf2b0e5be4bcb2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $21cf2b0e5be4bcb2$var$load("ctZCD"),
    $21cf2b0e5be4bcb2$var$load("9xrtp")
]).then(()=>parcelRequire('7NlMU'));

});

parcelRegister("5rpc8", function(module, exports) {

let $3f6304864e5a41ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3f6304864e5a41ea$var$load("iFcso").then(()=>parcelRequire('9NHjX'));

});


parcelRegister("cOelw", function(module, exports) {

$parcel$export(module.exports, "default", () => $59486e023b77d45f$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $gwFzn = parcelRequire("gwFzn");

var $59486e023b77d45f$export$2e2bcd8739ae039 = {
    'recommendation-jsw-jtbd': /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hyLZB")))
};

});
parcelRegister("hyLZB", function(module, exports) {

let $cc8ad6f4de353775$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cc8ad6f4de353775$var$load("ct3kN"),
    $cc8ad6f4de353775$var$load("8gQKz"),
    $cc8ad6f4de353775$var$load("ctZCD"),
    $cc8ad6f4de353775$var$load("7Q0UC"),
    $cc8ad6f4de353775$var$load("6gEtt")
]).then(()=>parcelRequire('7HoFq'));

});



parcelRegister("ePT1r", function(module, exports) {

$parcel$export(module.exports, "withAppSwitcherDiscoverySectionIntlProvider", () => $a62d024fdde04888$export$b73a0b4f9b1b8821);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $jQRRW = parcelRequire("jQRRW");

var $8SCD0 = parcelRequire("8SCD0");

var $3nDO6 = parcelRequire("3nDO6");

var $kdvUL = parcelRequire("kdvUL");

var $dDQ6d = parcelRequire("dDQ6d");
const $a62d024fdde04888$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $8SCD0.messagesLoader)(locale),
        (0, $3nDO6.messagesLoader)(locale),
        (0, $kdvUL.messagesLoader)(locale),
        (0, $dDQ6d.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $a62d024fdde04888$export$b73a0b4f9b1b8821 = (Component)=>{
    return (0, $jQRRW.withIntlProvider)({
        messagesLoader: $a62d024fdde04888$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("dDQ6d", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $cae2500566e87d72$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5opuK = parcelRequire("5opuK");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cae2500566e87d72$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $cae2500566e87d72$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("3GwQ2")));
        case 'da':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("3IwHT")));
        case 'de':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("6hqf5")));
        case 'en-GB':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("lpboR")));
        case 'en-US':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("aeTXi")));
        case 'en-XA':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("cnbsD")));
        case 'en-XB':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("lLbTn")));
        case 'en-ZZ':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("8h9HB")));
        case 'en':
            return $cae2500566e87d72$var$importHelper(await Promise.resolve((parcelRequire("5opuK"))));
        case 'es':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("c6oiS")));
        case 'et':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("5XCUk")));
        case 'fi':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("1sVbz")));
        case 'fr':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("42OP3")));
        case 'hu':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jzR8j")));
        case 'it':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("g7f9v")));
        case 'ja':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("cVW7q")));
        case 'ko':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("hhRyt")));
        case 'nb':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("lCjUi")));
        case 'nl':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("gL82Z")));
        case 'pl':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jH9Rb")));
        case 'pt-BR':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("6WD2N")));
        case 'ro':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("3MaVp")));
        case 'ru':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("5byCF")));
        case 'sv':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("1HsON")));
        case 'th':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("fBjos")));
        case 'tr':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jFRIs")));
        case 'uk':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jNTMO")));
        case 'vi':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("1w270")));
        case 'zh-CN':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("4bKgg")));
        case 'zh-TW':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jqQ4G")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5opuK));
    }
};

});
parcelRegister("5opuK", function(module, exports) {
module.exports = JSON.parse('{"trailblazers.recommendation-jsw-jtbd.marketing.description":[{"type":0,"value":"Easily plan and prioritize work"}],"trailblazers.recommendation-jsw-jtbd.marketing.jtbd":[{"type":0,"value":"Marketing project"}],"trailblazers.recommendation-jsw-jtbd.operations.description":[{"type":0,"value":"Visualize, plan, and finish work"}],"trailblazers.recommendation-jsw-jtbd.operations.jtbd":[{"type":0,"value":"Operations project"}],"trailblazers.recommendation-jsw-jtbd.pm.description":[{"type":0,"value":"See work in to-do, doing, done"}],"trailblazers.recommendation-jsw-jtbd.pm.jtbd":[{"type":0,"value":"Plan and track work"}],"trailblazers.recommendation-jsw-jtbd.swe.description":[{"type":0,"value":"Track work from start to finish"}],"trailblazers.recommendation-jsw-jtbd.swe.jtbd":[{"type":0,"value":"Project tracker"}],"trailblazers.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"trailblazers.xflow-notification-end-user-added-jira.message-template.email.subject":[{"type":0,"value":"\uD83C\uDF89 "},{"type":1,"value":"name"},{"type":0,"value":" has started using Jira"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.admin-url.no-translate":[{"type":0,"value":"admin.atlassian.com"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.headline":[{"type":1,"value":"name"},{"type":0,"value":" has started using Jira!"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.lead-paragraph":[{"type":0,"value":"Jira has been added to "},{"type":1,"value":"instanceUrl"},{"type":0,"value":". You don\u2019t need to do anything. "},{"children":[{"type":0,"value":"Jira is free for up to 10 users."}],"type":8,"value":"b"},{"type":0,"value":" You can cancel any time at "}],"trailblazers.xflow-notification-end-user-added-jira.message.email.sent-by-atlassian":[{"type":0,"value":"This message has been sent to you by Atlassian Cloud"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.take-tour.button":[{"type":0,"value":"Take a tour"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.achievable-tasks":[{"type":0,"value":"\uD83D\uDE80 Jira is a tool designed to break down any idea into achievable tasks."}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.connect-realtime":[{"type":0,"value":"\u2194\uFE0F Connect real-time data from Jira to any document in Confluence, no more copy paste."}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.visualise":[{"type":0,"value":"\uD83D\uDC40 Visualize your projects in lists, boards, backlogs, and more."}]}');

});

parcelRegister("3GwQ2", function(module, exports) {

let $2aeec45ee59a2728$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2aeec45ee59a2728$var$load("br5B5").then(()=>parcelRequire('g1ao0'));

});

parcelRegister("3IwHT", function(module, exports) {

let $2b4eda0e1f292e91$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2b4eda0e1f292e91$var$load("gjHAC").then(()=>parcelRequire('btnnE'));

});

parcelRegister("6hqf5", function(module, exports) {

let $4928afcad4972962$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4928afcad4972962$var$load("50jL1").then(()=>parcelRequire('bGslt'));

});

parcelRegister("lpboR", function(module, exports) {

let $f954c690c84bbd08$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f954c690c84bbd08$var$load("icT1H").then(()=>parcelRequire('1a85K'));

});

parcelRegister("aeTXi", function(module, exports) {

let $77469dc2c2fc427c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $77469dc2c2fc427c$var$load("jHACf").then(()=>parcelRequire('blZ2O'));

});

parcelRegister("cnbsD", function(module, exports) {

let $902085ed4bef4bd1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $902085ed4bef4bd1$var$load("gxykq").then(()=>parcelRequire('aLFng'));

});

parcelRegister("lLbTn", function(module, exports) {

let $fd7736515b60a673$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd7736515b60a673$var$load("jwi3q").then(()=>parcelRequire('kLNrh'));

});

parcelRegister("8h9HB", function(module, exports) {

let $60676fefbd95d8f6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $60676fefbd95d8f6$var$load("4vq5I").then(()=>parcelRequire('8KTi9'));

});

parcelRegister("c6oiS", function(module, exports) {

let $8cf8e5bf6d204896$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8cf8e5bf6d204896$var$load("3IaOg").then(()=>parcelRequire('1Lf8R'));

});

parcelRegister("5XCUk", function(module, exports) {

let $4570a4a84c58f57e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4570a4a84c58f57e$var$load("c1t91").then(()=>parcelRequire('5X1X6'));

});

parcelRegister("1sVbz", function(module, exports) {

let $1114c3d3ce040e71$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1114c3d3ce040e71$var$load("5x1Zd").then(()=>parcelRequire('eA4kS'));

});

parcelRegister("42OP3", function(module, exports) {

let $2f1ec59a18976fbf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2f1ec59a18976fbf$var$load("eNry3").then(()=>parcelRequire('l5c5e'));

});

parcelRegister("jzR8j", function(module, exports) {

let $e40a80508499d20d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e40a80508499d20d$var$load("qOVvt").then(()=>parcelRequire('lKBwT'));

});

parcelRegister("g7f9v", function(module, exports) {

let $bbb90db43b474427$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bbb90db43b474427$var$load("cLRtU").then(()=>parcelRequire('CZrZ8'));

});

parcelRegister("cVW7q", function(module, exports) {

let $96a7e414355b7f08$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $96a7e414355b7f08$var$load("fWDs2").then(()=>parcelRequire('86TZ1'));

});

parcelRegister("hhRyt", function(module, exports) {

let $c95d91196c453dac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c95d91196c453dac$var$load("isQud").then(()=>parcelRequire('6aeYa'));

});

parcelRegister("lCjUi", function(module, exports) {

let $fbcc96b653635be8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fbcc96b653635be8$var$load("iX3CG").then(()=>parcelRequire('f34NH'));

});

parcelRegister("gL82Z", function(module, exports) {

let $c3374727dc4edef4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3374727dc4edef4$var$load("5GFyb").then(()=>parcelRequire('jiVgR'));

});

parcelRegister("jH9Rb", function(module, exports) {

let $e569add61732189e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e569add61732189e$var$load("fDZox").then(()=>parcelRequire('5zdhe'));

});

parcelRegister("6WD2N", function(module, exports) {

let $50e6723422ce5ed2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $50e6723422ce5ed2$var$load("gYq2J").then(()=>parcelRequire('gxD3N'));

});

parcelRegister("3MaVp", function(module, exports) {

let $2bfe543f00b3aa12$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2bfe543f00b3aa12$var$load("4MDcN").then(()=>parcelRequire('8A4Kb'));

});

parcelRegister("5byCF", function(module, exports) {

let $3c68d62658a6aa3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3c68d62658a6aa3b$var$load("djU0u").then(()=>parcelRequire('3qkos'));

});

parcelRegister("1HsON", function(module, exports) {

let $13d02953f2f14596$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $13d02953f2f14596$var$load("gSB6X").then(()=>parcelRequire('fMlpz'));

});

parcelRegister("fBjos", function(module, exports) {

let $b5b95adfdb94a6e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b5b95adfdb94a6e9$var$load("9s4Da").then(()=>parcelRequire('8LZxx'));

});

parcelRegister("jFRIs", function(module, exports) {

let $e52b838c595e4f8b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e52b838c595e4f8b$var$load("f73pl").then(()=>parcelRequire('iZMLO'));

});

parcelRegister("jNTMO", function(module, exports) {

let $e6adddef2b4d5886$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e6adddef2b4d5886$var$load("jmWj5").then(()=>parcelRequire('bFdEh'));

});

parcelRegister("1w270", function(module, exports) {

let $11aa6b04eea485a0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $11aa6b04eea485a0$var$load("inGUf").then(()=>parcelRequire('6PHXJ'));

});

parcelRegister("4bKgg", function(module, exports) {

let $30cc130971b667be$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $30cc130971b667be$var$load("9rQBn").then(()=>parcelRequire('br3Yo'));

});

parcelRegister("jqQ4G", function(module, exports) {

let $e258d6ee187d7316$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e258d6ee187d7316$var$load("4DECc").then(()=>parcelRequire('5xVqA'));

});




parcelRegister("hNJxa", function(module, exports) {

$parcel$export(module.exports, "fetchProductRecommendationsWithCollaborators", () => $0d4b4afaa84d28bb$export$30ea0038b891f1cf);

var $jLIWc = parcelRequire("jLIWc");

var $jIyl9 = parcelRequire("jIyl9");

var $dcO0p = parcelRequire("dcO0p");
/* Joinable Sites API was replaced by Product Recommendations API as part of productionizing the Joinable Sites
   experimental API. This code maps Product Recommendations API results into Joinable Sites API results for
   compatibility with existing UI elements.
 */ function $0d4b4afaa84d28bb$var$productRecommendationsUrl(baseUrl) {
    return baseUrl + '/v1/product-recommendations' + '?product=jira-software&product=jira-servicedesk&product=confluence&product=jira-product-discovery';
}
/*
	Experiment API endpoint used to get collaborators to provided products
	https://bitbucket.org/atlassian/experiment-api/src/master/src/experiments/cross-join-switcher/
*/ const $0d4b4afaa84d28bb$var$collaboratorsUrl = '/gateway/api/growth/cross-join-switcher/get-eligible-collaborators';
// tenantedProducts and nonTenantedProducts used to identify which ARIs contain cloudId
// Also used to convert resourceOwner strings to JoinableSites product strings
const $0d4b4afaa84d28bb$var$supportedTenantedProducts = {
    confluence: (0, $dcO0p.ProductKey).CONFLUENCE,
    'jira-software': (0, $dcO0p.ProductKey).JIRA_SOFTWARE,
    'jira-product-discovery': (0, $dcO0p.ProductKey).JIRA_PRODUCT_DISCOVERY,
    'jira-servicedesk': (0, $dcO0p.ProductKey).JIRA_SERVICE_DESK
};
const $0d4b4afaa84d28bb$var$tenantedProductsToProduct = {
    [(0, $dcO0p.ProductKey).CONFLUENCE]: 'confluence',
    [(0, $dcO0p.ProductKey).JIRA_SOFTWARE]: 'jira-software',
    [(0, $dcO0p.ProductKey).JIRA_PRODUCT_DISCOVERY]: (0, $dcO0p.ProductKey).JIRA_PRODUCT_DISCOVERY,
    [(0, $dcO0p.ProductKey).JIRA_SERVICE_DESK]: 'jira-servicedesk'
};
function $0d4b4afaa84d28bb$var$handleCapabilities(capabilities) {
    return capabilities?.filter((inputResource)=>{
        const parsedAri = (0, $jLIWc.AnyAri).parse(inputResource.resourceId);
        return $0d4b4afaa84d28bb$var$supportedTenantedProducts[parsedAri.resourceOwner] && parsedAri.resourceType === 'site';
    }).reduce((sites, inputValue, index)=>{
        const ari = (0, $jLIWc.AnyAri).parse(inputValue.resourceId);
        const sitesProducts = sites[ari.resourceId]?.products;
        if (sitesProducts) {
            sitesProducts[$0d4b4afaa84d28bb$var$supportedTenantedProducts[ari.resourceOwner]] = {
                collaborators: [],
                productUrl: inputValue.url,
                capability: inputValue.capability
            };
            return sites;
        }
        try {
            // Add site with this product
            const url = new URL(inputValue.url);
            const products = {};
            products[$0d4b4afaa84d28bb$var$supportedTenantedProducts[ari.resourceOwner]] = {
                collaborators: [],
                productUrl: inputValue.url,
                capability: inputValue.capability
            };
            sites[ari.resourceId] = {
                cloudId: ari.resourceId,
                url: url.origin,
                displayName: inputValue.displayName,
                products: products,
                relevance: Math.max(1000 - index, 0)
            };
            return sites;
        } catch (e) {
            return sites;
        }
    }, {});
}
function $0d4b4afaa84d28bb$var$convertProductRecommendationsResponseToJoinableSitesResponse(input) {
    const joinedCapabilities = $0d4b4afaa84d28bb$var$handleCapabilities(input.capability?.DIRECT_ACCESS.map((site)=>({
            ...site,
            capability: 'DIRECT_ACCESS'
        })).concat(input.capability?.REQUEST_ACCESS.map((site)=>({
            ...site,
            capability: 'REQUEST_ACCESS'
        }))));
    return {
        sites: Object.values(joinedCapabilities)
    };
}
function $0d4b4afaa84d28bb$var$isPublicEmailDomainError(body) {
    // Public Email Domain Error returns a body with the following content:
    // {"code":"email-public-domain","message":"Request requires a domain which is not public"}
    return body?.code === 'email-public-domain';
}
const $0d4b4afaa84d28bb$var$emptyProductRecommendationResponse = {
    capability: {
        DIRECT_ACCESS: [],
        REQUEST_ACCESS: []
    }
};
const $0d4b4afaa84d28bb$export$194985100c06d296 = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then(async (response)=>{
        const jsonPromise = response.json();
        if (response.ok) return jsonPromise;
        if (response.status === 400) {
            const json = await jsonPromise;
            if ($0d4b4afaa84d28bb$var$isPublicEmailDomainError(json)) return $0d4b4afaa84d28bb$var$emptyProductRecommendationResponse;
        }
        throw new (0, $jIyl9.FetchError)(`Unable to fetch ${url} ${response.status} ${response.statusText}`, response.status);
    }).catch(()=>{
        throw new (0, $jIyl9.FetchError)('Network Error', undefined);
    });
async function $0d4b4afaa84d28bb$export$3273ac3481dc0616(cloudId = '', baseUrl = '') {
    const response = await $0d4b4afaa84d28bb$export$194985100c06d296($0d4b4afaa84d28bb$var$productRecommendationsUrl(baseUrl), {
        method: 'get'
    });
    const sitesResponse = $0d4b4afaa84d28bb$var$convertProductRecommendationsResponseToJoinableSitesResponse(response);
    if (!cloudId) return sitesResponse;
    const filteredSites = sitesResponse?.sites?.filter((site)=>site.cloudId === cloudId);
    // This mapping is required for calling the get-eligible-collaborators endpoint
    const flattenedProducts = filteredSites?.flatMap((site)=>Object.keys(site.products || []).map((productName)=>$0d4b4afaa84d28bb$var$tenantedProductsToProduct[productName]));
    if (!filteredSites || filteredSites?.length === 0 || flattenedProducts?.length === 0) return {
        sites: filteredSites
    };
    const collaboratorsResponse = await fetch($0d4b4afaa84d28bb$var$collaboratorsUrl, {
        method: 'POST',
        body: JSON.stringify({
            products: flattenedProducts,
            cloudId: cloudId
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!collaboratorsResponse.ok) return {
        sites: filteredSites
    };
    const collaboratorsJson = await collaboratorsResponse.json();
    // Renames key with tenantedProducts and filters out empty responses
    const updatedProductCollaborators = Object.fromEntries(Object.entries(collaboratorsJson).filter((item)=>Array.isArray(item[1]) && item[1]?.length !== 0).map((item)=>{
        return [
            $0d4b4afaa84d28bb$var$supportedTenantedProducts[item[0]] || item[0],
            item[1].map(({ userProfile: userProfile })=>({
                    displayName: userProfile?.name || '',
                    avatarUrl: userProfile?.picture || ''
                }))
        ];
    }));
    const updatedProductCollaboratorsKeys = Object.keys(updatedProductCollaborators);
    // Inject collaborators with each related product
    // Inject users with each site.
    const sitesWithCollaborators = filteredSites.map((site)=>{
        updatedProductCollaboratorsKeys.forEach((collaboratorProductKey)=>{
            if (site?.products?.[collaboratorProductKey]) site.products[collaboratorProductKey].collaborators = updatedProductCollaborators[collaboratorProductKey];
        });
        site.users = Object.keys(site?.products || {}).reduce((users, product)=>{
            users[product] = updatedProductCollaborators[product] || [];
            return users;
        }, {});
        return site;
    });
    const updatedSiteResponse = {
        sites: sitesWithCollaborators
    };
    return updatedSiteResponse;
}
const $0d4b4afaa84d28bb$export$30ea0038b891f1cf = (baseUrl)=>({ cloudId: cloudId })=>$0d4b4afaa84d28bb$export$3273ac3481dc0616(cloudId, baseUrl);

});

parcelRegister("1Y265", function(module, exports) {

$parcel$export(module.exports, "customShowFlag", () => $9486f2e1dfc1398c$export$90897e206b3c86f5);
const $9486f2e1dfc1398c$var$appearanceMappedToConfluenceFlagType = (appearance)=>{
    switch(appearance){
        case 'normal':
        case 'success':
            return 'success-circle';
        default:
            return appearance;
    }
};
const $9486f2e1dfc1398c$export$90897e206b3c86f5 = (flags)=>(flag)=>{
        const { title: title, description: description, appearance: appearance, actions: actions } = flag;
        flags.showFlag({
            type: $9486f2e1dfc1398c$var$appearanceMappedToConfluenceFlagType(appearance),
            title: title,
            description: description,
            close: 'auto',
            actions: actions
        });
    };

});


//# sourceMappingURL=en.5b954ada.js.map
